// // import {
// //   Button,
// //   Card,
// //   CardContent,
// //   Grid,
// //   TextField,
// //   Typography,
// //   Divider,
// //   Modal,
// //   Box,
// //   Table,
// //   CircularProgress,
// //   LinearProgress,
// //   InputAdornment,
// // } from "@mui/material";
// // import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import HOST_URL from "../../../utils/Url";
// // import { useFormik } from "formik";
// // import * as Yup from "yup";
// // import { useTranslation } from "react-i18next";
// // import { toast } from "react-toastify";
// // import ToastApp from "../../../ToastApp";
// // import Autocomplete from "@mui/material/Autocomplete";
// // import nopdf from "../../../assets/images/nopdf.png";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import AddCircleIcon from "@mui/icons-material/AddCircle";
// // import AiIcon from "@mui/icons-material/Psychology";
// // import moment from "moment";
// // import logo from "../../../assets/images/qq.png";
// // import { getSecureDevId } from "../../../utils/storageHelpers";

// // const modalStyle = {
// //   position: "absolute" as "absolute",
// //   top: "50%",
// //   left: "50%",
// //   transform: "translate(-50%, -50%)",
// //   width: "80vw",
// //   height: "85vh",
// //   bgcolor: "background.paper",
// //   border: "1px solid #000",
// //   boxShadow: 24,
// //   p: 4,
// //   borderRadius: "10px",
// //   overflowY: "auto",
// // };

// // type Props = {};
// // interface SelectOption {
// //   value: string | number;
// //   label: string;
// // }

// // const documentContentKeywords: Record<
// //   string,
// //   { keywords: string[]; typeLabel: string; threshold: number; regex?: RegExp[] }
// // > = {
// //   FLEET_VEHICLE_REPORT: {
// //     keywords: [
// //       "vehicle data",
// //       "vehicle no",
// //       "vehicle type",
// //       "time consumption",
// //       "fuel consumpt",
// //       "tipper",
// //       "dumper",
// //       "loader",
// //       "skid steer",
// //       "tata",
// //       "leyland",
// //       "truck",
// //       "hrs",
// //       "mins",
// //       "sec",
// //       "mt",
// //     ],
// //     regex: [
// //       /[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i,
// //       /CH\.?NO\.?\s?\d+/i,
// //     ],
// //     typeLabel: "Fleet Report / Vehicle Data",
// //     threshold: 4,
// //   },
// //   RESUME: {
// //     keywords: [
// //       "resume",
// //       "cv",
// //       "curriculum vitae",
// //       "experience",
// //       "education",
// //       "skills",
// //       "objective",
// //       "summary",
// //       "references",
// //       "career",
// //       "employment history",
// //       "qualification",
// //     ],
// //     typeLabel: "Resume/CV",
// //     threshold: 2,
// //   },
// //   INVOICE: {
// //     keywords: [
// //       "invoice",
// //       "bill",
// //       "receipt",
// //       "amount due",
// //       "invoice #",
// //       "invoice number",
// //       "bill to",
// //       "ship to",
// //       "item",
// //       "quantity",
// //       "price",
// //       "total",
// //       "tax",
// //       "vat",
// //       "payment terms",
// //     ],
// //     typeLabel: "Invoice/Bill",
// //     threshold: 2,
// //   },
// //   LETTER: {
// //     keywords: [
// //       "dear",
// //       "sincerely",
// //       "yours faithfully",
// //       "regards",
// //       "letter",
// //       "correspondence",
// //       "enclosed",
// //       "subject:",
// //       "to whom it may concern",
// //     ],
// //     typeLabel: "Letter/Correspondence",
// //     threshold: 2,
// //   },
// //   NEWS_ARTICLE: {
// //     keywords: [
// //       "news",
// //       "article",
// //       "headline",
// //       "byline",
// //       "published",
// //       "edition",
// //       "column",
// //       "editorial",
// //       "reporter",
// //       "source",
// //       "dateline",
// //       "breaking news",
// //       "journal",
// //     ],
// //     typeLabel: "News Article/Publication",
// //     threshold: 2,
// //   },
// //   AGREEMENT: {
// //     keywords: [
// //       "agreement",
// //       "contract",
// //       "terms and conditions",
// //       "party a",
// //       "party b",
// //       "whereas",
// //       "heretofore",
// //       "witnesseth",
// //       "binding",
// //       "legal",
// //       "nda",
// //       "memorandum of understanding",
// //     ],
// //     typeLabel: "Agreement/Contract",
// //     threshold: 2,
// //   },
// //   REPORT: {
// //     keywords: [
// //       "report",
// //       "summary",
// //       "analysis",
// //       "findings",
// //       "conclusion",
// //       "executive summary",
// //       "introduction",
// //       "methodology",
// //       "research",
// //       "study",
// //       "annual report",
// //     ],
// //     typeLabel: "General Report/Summary",
// //     threshold: 2,
// //   },
// //   FORM: {
// //     keywords: [
// //       "form",
// //       "application",
// //       "please fill",
// //       "submit",
// //       "signature",
// //       "date of birth",
// //       "personal details",
// //       "declaration",
// //     ],
// //     typeLabel: "Form/Application",
// //     threshold: 2,
// //   },
// //   PRESENTATION: {
// //     keywords: [
// //       "presentation",
// //       "slides",
// //       "powerpoint",
// //       "keynote",
// //       "deck",
// //       "slide deck",
// //     ],
// //     typeLabel: "Presentation",
// //     threshold: 1,
// //   },
// //   SPREADSHEET: {
// //     keywords: [
// //       "spreadsheet",
// //       "excel",
// //       "sheet",
// //       "workbook",
// //       "data",
// //       "table",
// //       "csv",
// //     ],
// //     typeLabel: "Spreadsheet/Data",
// //     threshold: 1,
// //   },
// // };

// // const simulateAIDocumentTypeDetection = async (
// //   _base64Pdf: string,
// //   currentFileName: string,
// //   t: (key: string, defaultValue?: string) => string,
// // ): Promise<string | null> => {
// //   return new Promise((resolve) => {
// //     const contentToAnalyze = currentFileName
// //       .toLowerCase()
// //       .replace(/[_-]/g, " ");
// //     setTimeout(() => {
// //       let detectedTypeLabel: string | null = null;
// //       let bestMatchScore = 0;
// //       let bestMatchKey: string | null = null;

// //       for (const docKey in documentContentKeywords) {
// //         const { keywords, threshold, regex } = documentContentKeywords[docKey];
// //         let currentScore = 0;
// //         if (regex && regex.length > 0) {
// //           for (const r of regex) {
// //             if (r.test(contentToAnalyze)) {
// //               currentScore += 3;
// //               break;
// //             }
// //           }
// //         }
// //         for (const keyword of keywords) {
// //           if (contentToAnalyze.includes(keyword)) {
// //             currentScore++;
// //             if (
// //               docKey
// //                 .toLowerCase()
// //                 .replace(/_/g, " ")
// //                 .includes(keyword.split(" ")[0])
// //             ) {
// //               currentScore += 1;
// //             }
// //           }
// //         }
// //         if (currentScore >= threshold && currentScore > bestMatchScore) {
// //           bestMatchScore = currentScore;
// //           bestMatchKey = docKey;
// //         }
// //       }

// //       if (bestMatchKey) {
// //         detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
// //         if (
// //           bestMatchKey === "FLEET_VEHICLE_REPORT" &&
// //           contentToAnalyze.includes("fuel consum")
// //         ) {
// //           detectedTypeLabel = t(
// //             "text.aiFleetFuelReport",
// //             "Fleet Report / Vehicle Fuel Data",
// //           );
// //         }
// //       } else {
// //         if (currentFileName.toLowerCase().endsWith(".pdf")) {
// //           detectedTypeLabel = t("text.aiGenericDocument", "Generic Document");
// //         }
// //       }
// //       resolve(detectedTypeLabel);
// //     }, 1500);
// //   });
// // };
// // const isValidFileType = (file: File): boolean => {
// //   // Only allow PDF MIME types
// //   const allowedMimeTypes = [
// //     "application/pdf",
// //   ];

// //   // Only allow PDF extensions
// //   const allowedExtensions = [".pdf"];

// //   // Get the file name
// //   const fileName = file.name.toLowerCase();

// //   // Check if the file extension is .pdf
// //   const fileExtension = fileName.substring(fileName.lastIndexOf("."));
// //   if (!allowedExtensions.includes(fileExtension)) {
// //     console.log("Rejected: Invalid file extension");
// //     return false;
// //   }

// //   // Check if MIME type is allowed (only PDF)
// //   if (!allowedMimeTypes.includes(file.type)) {
// //     console.log("Rejected: Invalid MIME type");
// //     return false;
// //   }

// //   // Check for dangerous double extensions (like .pdf.exe or .pdf.bat)
// //   // But allow legitimate multiple dots in filename like "Maximum.fine.Payer.pdf"
// //   const fileNameParts = fileName.split('.');

// //   // If there are more than 2 parts (multiple dots)
// //   if (fileNameParts.length > 2) {
// //     // Check if the second last part looks like a dangerous extension
// //     const secondLastPart = fileNameParts[fileNameParts.length - 2];

// //     // List of dangerous extensions that should never appear in the middle
// //     const dangerousExtensions = ['exe', 'bat', 'cmd', 'sh', 'msi', 'dll', 'vbs', 'js', 'jar', 'py', 'rb', 'php', 'asp'];

// //     // If the second last part is a dangerous extension, reject
// //     if (dangerousExtensions.includes(secondLastPart)) {
// //       console.log("Rejected: Dangerous double extension detected");
// //       return false;
// //     }

// //     // Also check if the second last part looks like an extension but is actually a word
// //     // For example: "file.txt.pdf" should be rejected, but "Maximum.fine.Payer.pdf" should be accepted
// //     // We'll do a basic check - if the second last part is longer than 5 chars, it's probably a word
// //     if (secondLastPart.length <= 5 && /^[a-zA-Z0-9]+$/.test(secondLastPart)) {
// //       // It might be an extension, but we need to check if it's a common word
// //       const commonWords = ['fine', 'payer', 'file', 'name', 'test', 'data', 'info', 'main', 'part', 'draft', 'final'];
// //       if (!commonWords.includes(secondLastPart)) {
// //         console.log("Rejected: Suspicious double extension pattern");
// //         return false;
// //       }
// //     }
// //   }

// //   // Additional check for executable files disguised as PDFs
// //   if (
// //     file.type === "application/x-msdownload" ||
// //     file.type === "application/x-dosexec" ||
// //     file.type === "application/x-executable"
// //   ) {
// //     console.log("Rejected: Executable file detected");
// //     return false;
// //   }

// //   return true;
// // };

// // const DocumentEntryAdd = (props: Props) => {
// //   const { i18n, t }: any = useTranslation();

// //   const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
// //   const [Subject, setSubject] = useState<SelectOption[]>([]);
// //   const [Division, setDivision] = useState<SelectOption[]>([]);
// //   const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]); // New State
// //   const today = moment().format("YYYY-MM-DD");
// //   const [tableData, setTableData] = useState<any[]>([]);
// //   const [pDate, setPDate] = useState(today || "");
// //   const [keywords, setKeywords] = useState("");
// //   const [fileName, setfileName] = useState("");
// //   const [pdfView, setPdfView] = useState("");
// //   const [loader, setLoader] = useState(false);
// //   const [maxFileNo, setMaxFileNo] = useState("");
// //   const [isDetectingAttachmentType, setIsDetectingAttachmentType] =
// //     useState(false);
// //   const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] =
// //     useState<string | null>(null);
// //   const [Opens, setOpen] = React.useState(false);
// //   const [Img, setImg] = useState<string>("");
// //   const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
// //   const [originalExtension, setOriginalExtension] = useState("");

// //   const handlePanClose1 = () => setOpen(false);
// //   const modalOpenHandle1 = (previewUrl: string) => {
// //     setOpen(true);
// //     setImg(previewUrl);
// //   };
// //   const devId = getSecureDevId();
// //   const initialDivisionId = devId === null || devId === 0 ? "" : String(devId);

// //   useEffect(() => {
// //     getFileType();
// //     getSubject();
// //     getDivision();
// //     getSubDepartment(); // Initial Load
// //     getMaxFileNumber();
// //   }, []);

// //   const getMaxFileNumber = async () => {
// //     try {
// //       const response = await axios.get(
// //         HOST_URL.HOST_URL2 + `DocMangr/GetFileNoMax`,
// //       );
// //       const fileNo = response.data.data[0].fileNo;
// //       setMaxFileNo(fileNo);
// //       formik.setFieldValue("fileNo", fileNo);
// //     } catch (error) {
// //       toast.error(t("text.ErrorFetchingMaxFileNo"));
// //     }
// //   };

// //   const getFileType = () => {
// //     const collectData = { docID: -1, parentDocId: -1, userId: "" };
// //     axios
// //       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
// //       .then((res) => {
// //         const arr: SelectOption[] =
// //           res?.data?.data?.map((item: any) => ({
// //             label: item.doc_Name,
// //             value: String(item.docID),
// //           })) || [];
// //         setTypeOption(arr);
// //       });
// //   };

// //   const getSubject = () => {
// //     const collectData = { sID: -1 };
// //     axios
// //       .post(
// //         HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
// //         collectData,
// //       )
// //       .then((res) => {
// //         const arr: SelectOption[] =
// //           res.data.data.map((item: any) => ({
// //             label: item.subject,
// //             value: String(item.sId),
// //           })) || [];
// //         setSubject(arr);
// //       });
// //   };

// //   const getDivision = () => {
// //     const collectData = {
// //       id: initialDivisionId === "" ? -1 : initialDivisionId,
// //       nodeID: -1,
// //       titleID: -1,
// //     };
// //     axios
// //       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
// //       .then((res) => {
// //         const arr: SelectOption[] =
// //           res.data.data.map((item: any) => ({
// //             label: item.name,
// //             value: String(item.id),
// //           })) || [];
// //         setDivision(arr);
// //       });
// //   };

// //   // New function to get Sub-Departments
// //   const getSubDepartment = (deptId: number = -1) => {
// //     const collectData = { subDeptID: -1, deptID: deptId };
// //     axios
// //       .post(
// //         HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
// //         collectData,
// //       )
// //       .then((res) => {
// //         const arr: SelectOption[] =
// //           res.data.data.map((item: any) => ({
// //             label: item.subDeptName,
// //             value: String(item.subDeptID),
// //           })) || [];
// //         setSubDepartments(arr);
// //       })
// //       .catch((error) => {
// //         console.error("Error fetching sub departments:", error);
// //       });
// //   };

// //   let navigate = useNavigate();

// //   const validationSchema = Yup.object({
// //     fileNo: Yup.string().required(t("text.reqFileNo", "File No is required")),
// //     subsubjId: Yup.string()
// //       .nullable()
// //       .required(t("text.reqsubsubjId", "Subject is required")),
// //     divisionid: Yup.string()
// //       .nullable()
// //       .required(t("text.reqdivisionid", "Division is required")),
// //     subDeptID: Yup.string()
// //       .nullable()
// //       .required(t("text.reqSubDept", "Sub Department is required")), // Added validation
// //     fileTypId: Yup.string()
// //       .nullable()
// //       .required(t("text.reqfileTypeID", "File Type is required")),
// //     synopsis: Yup.string().required(
// //       t("text.reqFileName", "File Name/Synopsis is required"),
// //     ),
// //     member_DocFiles: Yup.array()
// //       .min(1, t("text.reqAttachment", "At least one attachment is required"))
// //       .required(t("text.reqAttachment", "Attachment is required")),
// //   });

// //   const formik: any = useFormik({
// //     initialValues: {
// //       fileNo: "",
// //       fileDef: "",
// //       synopsis: "",
// //       fDate: today || "",
// //       authPersn: "",
// //       subsubjId: null as string | null,
// //       fileTypId: null as string | null,
// //       createdate: today,
// //       user_Id: 1,
// //       perFr: today || "",
// //       perUt: today || "",
// //       member_DocFiles: [] as any[],
// //       divisionid: initialDivisionId === "" ? null : String(initialDivisionId),
// //       subDeptID: "", // Added to initial values
// //     },
// //     validationSchema: validationSchema,
// //     onSubmit: async (values) => {
// //       const submissionValues = { ...values, member_DocFiles: tableData };
// //       if (
// //         !submissionValues.member_DocFiles ||
// //         submissionValues.member_DocFiles.length === 0
// //       ) {
// //         toast.error(t("text.reqAttachment"));
// //         return;
// //       }
// //       setLoader(true);
// //       try {
// //         const response = await axios.post(
// //           HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
// //           submissionValues,
// //         );
// //         if (response.data.isSuccess) {
// //           toast.success(response.data.mesg);
// //           setLoader(false);
// //           setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
// //         } else {
// //           toast.error(response.data.mesg);
// //           setLoader(false);
// //         }
// //       } catch (error) {
// //         toast.error(t("text.ErrorSubmittingForm"));
// //         setLoader(false);
// //       }
// //     },
// //   });

// // //   const onTransctionChange = async (
// // //     event: React.ChangeEvent<HTMLInputElement>,
// // //   ) => {
// // //     if (event.target.files && event.target.files[0]) {
// // //       const file = event.target.files[0];
// // //      if (!isValidFileType(file)) {
// // //   toast.error(
// // //     t("text.invalidFileType", "Only PDF files are allowed")
// // //   );
// // //   event.target.value = ""; // Reset the file input
// // //   return;
// // // }
// // //       const fileURL = URL.createObjectURL(file);
// // //       const currentFileName = file.name;
// // //       const extIndex = currentFileName.lastIndexOf(".");
// // //       const withoutExt =
// // //         extIndex !== -1
// // //           ? currentFileName.substring(0, extIndex)
// // //           : currentFileName;
// // //       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : "";
// // //       setPdfView(fileURL);
// // //       setfileName(currentFileName);
// // //       setFileNameWithoutExt(withoutExt);
// // //       setOriginalExtension(ext);
// // //       setIsDetectingAttachmentType(true);
// // //       try {
// // //         const detectedLabel = await simulateAIDocumentTypeDetection(
// // //           "",
// // //           currentFileName,
// // //           t,
// // //         );
// // //         setCurrentAttachmentAiSuggestion(detectedLabel);
// // //       } finally {
// // //         setIsDetectingAttachmentType(false);
// // //       }
// // //     }
// // //   };
// // const onTransctionChange = async (
// //   event: React.ChangeEvent<HTMLInputElement>
// // ) => {
// //   if (event.target.files && event.target.files[0]) {
// //     const file = event.target.files[0];
// //     const fileName = file.name;

// //     // First validate the file
// //     if (!isValidFileType(file)) {
// //       toast.error(
// //         t("text.invalidFileType", "Only valid PDF files are allowed")
// //       );
// //       event.target.value = ""; // Reset the file input
// //       return;
// //     }

// //     const fileURL = URL.createObjectURL(file);
// //     const extIndex = fileName.lastIndexOf(".");
// //     const withoutExt =
// //       extIndex !== -1
// //         ? fileName.substring(0, extIndex)
// //         : fileName;
// //     const ext = extIndex !== -1 ? fileName.substring(extIndex) : "";

// //     // Ensure extension is .pdf
// //     if (ext.toLowerCase() !== ".pdf") {
// //       toast.error(t("text.onlyPdfAllowed", "Only PDF files are allowed"));
// //       event.target.value = "";
// //       return;
// //     }

// //     setPdfView(fileURL);
// //     setfileName(fileName);
// //     setFileNameWithoutExt(withoutExt);
// //     setOriginalExtension(ext);
// //     setCurrentAttachmentAiSuggestion(null);
// //     setIsDetectingAttachmentType(true);

// //     try {
// //       const detectedLabel = await simulateAIDocumentTypeDetection(
// //         "",
// //         fileName,
// //         t
// //       );
// //       setCurrentAttachmentAiSuggestion(detectedLabel);
// //       if (detectedLabel) {
// //         toast.info(
// //           t(
// //             "text.aiAttachmentCategorySuggestion",
// //             `AI suggests category: ${detectedLabel}`
// //           ),
// //           { autoClose: 3500 }
// //         );
// //       } else {
// //         toast.info(
// //           t(
// //             "text.aiNoSpecificCategoryForAttachment",
// //             "AI couldn't suggest a specific category."
// //           ),
// //           { autoClose: 3000 }
// //         );
// //       }
// //     } catch (aiError) {
// //       console.error("AI attachment category detection error:", aiError);
// //       toast.error(t("text.aiDetectionError"));
// //     } finally {
// //       setIsDetectingAttachmentType(false);
// //     }
// //   } else {
// //     // When no file is selected (user cancelled), reset everything
// //     setfileName("");
// //     setPdfView("");
// //     setFileNameWithoutExt("");
// //     setOriginalExtension("");
// //     setIsDetectingAttachmentType(false);
// //     setCurrentAttachmentAiSuggestion(null);

// //     // Ensure the input is cleared
// //     event.target.value = "";
// //   }
// // };
// // const addMoreRow = () => {
// //   if (!fileName || !pDate) {
// //     toast.warn(t("text.PleaseFillAttachmentDetails"));
// //     return;
// //   }

// //   const newRow = {
// //     id: Date.now(),
// //     pdFid: -1,
// //     pdfName: fileName,
// //     docMid: -1,
// //     keywords: keywords,
// //     subFtype: "",
// //     pDate: pDate,
// //     isMain: "",
// //     entryDate: moment().format("YYYY-MM-DD"),
// //     user_id: -1,
// //     pdfPath: "",
// //     pdfView: pdfView,
// //     srn: -1,
// //     isDelete: false,
// //   };

// //   const updatedTableData = [...tableData, newRow];
// //   setTableData(updatedTableData);
// //   formik.setFieldValue("member_DocFiles", updatedTableData);

// //   // Reset all file-related states
// //   setfileName("");
// //   setPdfView("");
// //   setFileNameWithoutExt("");
// //   setOriginalExtension("");
// //   setCurrentAttachmentAiSuggestion(null);

// //   // Reset the file input element
// //   const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
// //   if (fileInput) {
// //     fileInput.value = "";
// //   }
// // };

// //   const removeExtraRow = (id: any) => {
// //     const updatedTableData = tableData.filter((row) => row.id !== id);
// //     setTableData(updatedTableData);
// //     formik.setFieldValue("member_DocFiles", updatedTableData);
// //   };

// //   const back = useNavigate();
// //   const getAutocompleteValue = (
// //     options: SelectOption[],
// //     formikValue: string | null | number,
// //   ): SelectOption | null => {
// //     if (formikValue === null || formikValue === undefined) return null;
// //     return (
// //       options.find((option) => String(option.value) === String(formikValue)) ||
// //       null
// //     );
// //   };

// // const handleReset = () => {
// //   formik.resetForm();
// //   setTableData([]);
// //   setPDate(today || "");
// //   setKeywords("");
// //   setfileName("");
// //   setPdfView("");
// //   setFileNameWithoutExt("");
// //   setOriginalExtension("");
// //   setCurrentAttachmentAiSuggestion(null);
// //   setIsDetectingAttachmentType(false);

// //   // Reset max file number
// //   getMaxFileNumber();

// //   // Reset division to initial value
// //   formik.setFieldValue(
// //     "divisionid",
// //     initialDivisionId === "" ? null : String(initialDivisionId),
// //   );

// //   // Reset the file input element
// //   const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
// //   if (fileInput) {
// //     fileInput.value = "";
// //   }

// //   // Reset any other file inputs if they exist
// //   const fileInputs = document.querySelectorAll('input[type="file"]');
// //   fileInputs.forEach((input: any) => {
// //     input.value = "";
// //   });
// // };
// //   return (
// //     <div>
// //       <ToastApp />
// //       {loader && (
// //         <Box
// //           sx={{
// //             position: "fixed",
// //             top: 0,
// //             left: 0,
// //             width: "100vw",
// //             height: "100vh",
// //             display: "flex",
// //             justifyContent: "center",
// //             alignItems: "center",
// //             backgroundColor: "rgba(255, 255, 255, 0.7)",
// //             zIndex: (theme) => theme.zIndex.drawer + 50,
// //           }}
// //         >
// //           {" "}
// //           <Box
// //             sx={{
// //               display: "flex",
// //               flexDirection: "column",
// //               alignItems: "center",
// //               padding: 4,
// //               backgroundColor: "rgba(255,255,255,0.95)",
// //               borderRadius: "12px",
// //               boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
// //               border: "1px solid rgba(255, 255, 255, 0.18)",
// //             }}
// //           >
// //             {" "}
// //             <img
// //               src={logo}
// //               alt="Loading..."
// //               style={{ width: "120px", height: "auto", marginBottom: "24px" }}
// //             />{" "}
// //             <LinearProgress
// //               color="primary"
// //               sx={{ width: "200px", height: "8px", borderRadius: "4px" }}
// //             />{" "}
// //             <Typography
// //               variant="subtitle1"
// //               sx={{ marginTop: 2, color: "text.secondary" }}
// //             >
// //               {" "}
// //               {t("text.processing", "Processing, please wait...")}{" "}
// //             </Typography>{" "}
// //           </Box>{" "}
// //         </Box>
// //       )}

// //       <div
// //         style={{
// //           padding: "-5px 5px",
// //           backgroundColor: "#ffffff",
// //           borderRadius: "5px",
// //           marginTop: "3vh",
// //           filter: loader ? "blur(5px)" : "none",
// //         }}
// //       >
// //         <CardContent>
// //           <Typography
// //             variant="h5"
// //             textAlign="center"
// //             style={{ fontSize: "18px", fontWeight: 500 }}
// //           >
// //             {" "}
// //             {t("text.DocumentEntryAdd", "Document Entry Add")}{" "}
// //           </Typography>
// //           <Grid item sm={4} xs={12} style={{ marginTop: "-40px" }}>
// //             {" "}
// //             <Button
// //               type="button"
// //               onClick={() => back(-1)}
// //               variant="contained"
// //               style={{
// //                 backgroundColor: `var(--header-background)`,
// //                 minWidth: "40px",
// //               }}
// //             >
// //               {" "}
// //               <ArrowBackSharpIcon />{" "}
// //             </Button>{" "}
// //           </Grid>
// //           <Divider style={{ marginTop: "10px", marginBottom: "20px" }} />

// //           <form onSubmit={formik.handleSubmit}>
// //             <Grid container spacing={2}>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="fileNo"
// //                   name="fileNo"
// //                   label={
// //                     <span>
// //                       {t("text.EnterFileNo", "File No")}{" "}
// //                       <span
// //                         style={{
// //                           color:
// //                             formik.values.fileNo && !formik.errors.fileNo
// //                               ? "green"
// //                               : "red",
// //                         }}
// //                       >
// //                         *
// //                       </span>
// //                     </span>
// //                   }
// //                   value={formik.values.fileNo}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                   error={formik.touched.fileNo && Boolean(formik.errors.fileNo)}
// //                   helperText={
// //                     formik.touched.fileNo && (formik.errors.fileNo as string)
// //                   }
// //                   size="small"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="synopsis"
// //                   name="synopsis"
// //                   label={
// //                     <span>
// //                       {t("text.FileName", "File Name/Synopsis")}{" "}
// //                       <span
// //                         style={{
// //                           color:
// //                             formik.values.synopsis && !formik.errors.synopsis
// //                               ? "green"
// //                               : "red",
// //                         }}
// //                       >
// //                         *
// //                       </span>
// //                     </span>
// //                   }
// //                   value={formik.values.synopsis}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                   error={
// //                     formik.touched.synopsis && Boolean(formik.errors.synopsis)
// //                   }
// //                   helperText={
// //                     formik.touched.synopsis &&
// //                     (formik.errors.synopsis as string)
// //                   }
// //                   size="small"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="fileDef"
// //                   name="fileDef"
// //                   label={t("text.EnterFileDef", "File Definition")}
// //                   value={formik.values.fileDef}
// //                   onChange={formik.handleChange}
// //                   onBlur={formik.handleBlur}
// //                   size="small"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="perFr"
// //                   name="perFr"
// //                   label={t("text.EnterPeriodFileFrom", "Period From")}
// //                   value={formik.values.perFr}
// //                   onChange={formik.handleChange}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="perUt"
// //                   name="perUt"
// //                   label={t("text.EnterPeriodFileUpto", "Period Upto")}
// //                   value={formik.values.perUt}
// //                   onChange={formik.handleChange}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="authPersn"
// //                   name="authPersn"
// //                   label={t(
// //                     "text.EnterAuthenticatePerson",
// //                     "Authenticate Person",
// //                   )}
// //                   value={formik.values.authPersn}
// //                   onChange={formik.handleChange}
// //                   size="small"
// //                   fullWidth
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <TextField
// //                   id="fDate"
// //                   name="fDate"
// //                   label={t("text.EnterFileDate", "File Date")}
// //                   value={formik.values.fDate}
// //                   onChange={formik.handleChange}
// //                   InputLabelProps={{ shrink: true }}
// //                   size="small"
// //                   type="date"
// //                   fullWidth
// //                 />
// //               </Grid>

// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="fileTypId"
// //                   options={TypeOption}
// //                   value={getAutocompleteValue(
// //                     TypeOption,
// //                     formik.values.fileTypId,
// //                   )}
// //                   getOptionLabel={(option) => option.label}
// //                   onChange={(event, newValue) => {
// //                     formik.setFieldValue(
// //                       "fileTypId",
// //                       newValue ? String(newValue.value) : null,
// //                     );
// //                   }}
// //                   fullWidth
// //                   size="small"
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectFile", "Select File Type")} *
// //                         </span>
// //                       }
// //                       error={
// //                         formik.touched.fileTypId &&
// //                         Boolean(formik.errors.fileTypId)
// //                       }
// //                       helperText={
// //                         formik.touched.fileTypId &&
// //                         (formik.errors.fileTypId as string)
// //                       }
// //                     />
// //                   )}
// //                 />
// //               </Grid>
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="subsubjId"
// //                   options={Subject}
// //                   value={getAutocompleteValue(Subject, formik.values.subsubjId)}
// //                   getOptionLabel={(option) => option.label}
// //                   onChange={(event, newValue) => {
// //                     formik.setFieldValue(
// //                       "subsubjId",
// //                       newValue ? String(newValue.value) : null,
// //                     );
// //                   }}
// //                   fullWidth
// //                   size="small"
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectSubject", "Select Subject")} *
// //                         </span>
// //                       }
// //                       error={
// //                         formik.touched.subsubjId &&
// //                         Boolean(formik.errors.subsubjId)
// //                       }
// //                       helperText={
// //                         formik.touched.subsubjId &&
// //                         (formik.errors.subsubjId as string)
// //                       }
// //                     />
// //                   )}
// //                 />
// //               </Grid>

// //               {/* Division/Department Field */}
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="divisionid"
// //                   options={Division}
// //                   value={getAutocompleteValue(
// //                     Division,
// //                     formik.values.divisionid,
// //                   )}
// //                   getOptionLabel={(option) => option.label}
// //                   onChange={(event, newValue) => {
// //                     formik.setFieldValue(
// //                       "divisionid",
// //                       newValue ? String(newValue.value) : null,
// //                     );
// //                     getSubDepartment(Number(newValue?.value || -1));
// //                   }}
// //                   fullWidth
// //                   size="small"
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t(
// //                             "text.SelectDepartment",
// //                             "Select Division/Department",
// //                           )}{" "}
// //                           *
// //                         </span>
// //                       }
// //                       error={
// //                         formik.touched.divisionid &&
// //                         Boolean(formik.errors.divisionid)
// //                       }
// //                       helperText={
// //                         formik.touched.divisionid &&
// //                         (formik.errors.divisionid as string)
// //                       }
// //                     />
// //                   )}
// //                 />
// //               </Grid>

// //               {/* New Sub Department Field (Added) */}
// //               <Grid item lg={4} sm={6} xs={12}>
// //                 <Autocomplete
// //                   disablePortal
// //                   id="subDeptID"
// //                   options={subDepartments}
// //                   value={getAutocompleteValue(
// //                     subDepartments,
// //                     formik.values.subDeptID,
// //                   )}
// //                   getOptionLabel={(option) => option.label}
// //                   isOptionEqualToValue={(option, value) =>
// //                     String(option.value) === String(value?.value)
// //                   }
// //                   onChange={(event, newValue) => {
// //                     formik.setFieldValue(
// //                       "subDeptID",
// //                       newValue ? String(newValue.value) : null,
// //                     );
// //                   }}
// //                   fullWidth
// //                   size="small"
// //                   renderInput={(params) => (
// //                     <TextField
// //                       {...params}
// //                       label={
// //                         <span>
// //                           {t("text.SelectSubDept", "Select Sub Department")}{" "}
// //                           <span
// //                             style={{
// //                               color:
// //                                 formik.values.subDeptID &&
// //                                 !formik.errors.subDeptID
// //                                   ? "green"
// //                                   : "red",
// //                             }}
// //                           >
// //                             *
// //                           </span>
// //                         </span>
// //                       }
// //                       error={
// //                         formik.touched.subDeptID &&
// //                         Boolean(formik.errors.subDeptID)
// //                       }
// //                       helperText={
// //                         formik.touched.subDeptID &&
// //                         (formik.errors.subDeptID as string)
// //                       }
// //                     />
// //                   )}
// //                 />
// //               </Grid>

// //               <Grid item xs={12}>
// //                 <Divider sx={{ marginY: 2 }}>
// //                   <Typography variant="subtitle1">
// //                     {t("text.Attachments", "Attachments")}*
// //                   </Typography>
// //                 </Divider>
// //               </Grid>
// //               <Grid item container xs={12} spacing={2} alignItems="flex-start">
// //                 <Grid item xs={12} lg={2.5}>
// //                   <TextField
// //                     label={t("text.PeriodDate", "Period Date")}
// //                     value={pDate}
// //                     onChange={(e: any) => setPDate(e.target.value)}
// //                     InputLabelProps={{ shrink: true }}
// //                     size="small"
// //                     type="date"
// //                     fullWidth
// //                   />
// //                 </Grid>
// //                 <Grid item xs={12} lg={2}>
// //                   <TextField
// //                     label={t("text.Keywords", "Keywords")}
// //                     value={keywords}
// //                     onChange={(e: any) => setKeywords(e.target.value)}
// //                     size="small"
// //                     fullWidth
// //                   />
// //                 </Grid>


// // <Grid item xs={12} lg={3}>
// //   <TextField
// //     id="pdf_attach_file_input"
// //     name="pdf_attach_input"
// //     label={t("text.AttachedFile", "Attach File")}
// //     onChange={onTransctionChange}
// //     size="small"
// //     type="file"
// //     fullWidth
// //     style={{ backgroundColor: "white" }}
// //     InputLabelProps={{ shrink: true }}
// //     inputProps={{
// //       accept: ".pdf,application/pdf" // Only accept PDF files
// //     }}
// //   />
// //   <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
// //     {t("text.allowedFileTypes", "Only PDF files are allowed")}
// //   </Typography>
// //   {isDetectingAttachmentType && fileName && (
// //     <Box sx={{ width: '100%', mt: 0.5 }}>
// //       <LinearProgress variant="indeterminate" />
// //       <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
// //         {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
// //       </Typography>
// //     </Box>
// //   )}
// //   {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
// //     <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1 }}>
// //       <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
// //       <Typography variant="caption" component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
// //         {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
// //       </Typography>
// //     </Box>
// //   )}
// // </Grid>


// // <Grid item xs={12} lg={3}>
// //   <TextField
// //     id="fileName_display"
// //     name="fileName_display"
// //     label={t("text.EnterFileName", "Selected File")}
// //     value={fileNameWithoutExt}
// //     onChange={(e) => {
// //       let input = e.target.value.trim();

// //       // Don't automatically remove dots - they might be part of the name
// //       // Just ensure the final filename will have .pdf extension

// //       const forcedExt = ".pdf";

// //       setFileNameWithoutExt(input);
// //       setOriginalExtension(forcedExt);
// //       setfileName(input + forcedExt);
// //     }}
// //     size="small"
// //     fullWidth
// //     style={{ backgroundColor: "white" }}
// //     InputProps={{
// //       endAdornment: originalExtension ? (
// //         <InputAdornment
// //           position="end"
// //           disableTypography
// //           sx={{ 
// //             pointerEvents: "none", 
// //             userSelect: "none",
// //             color: "green",
// //             fontWeight: "bold"
// //           }}
// //         >
// //           {originalExtension}
// //         </InputAdornment>
// //       ) : null,
// //     }}
// //     InputLabelProps={{
// //       shrink: Boolean(fileNameWithoutExt || originalExtension),
// //     }}
// //     error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
// //     helperText={
// //       fileName && !fileName.toLowerCase().endsWith(".pdf")
// //         ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
// //         : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
// //     }
// //   />
// // </Grid>
// //                 <Grid item xs={12} lg={1.5}>
// //                   <Button
// //                     startIcon={<AddCircleIcon />}
// //                     variant="contained"
// //                     color="info"
// //                     fullWidth
// //                     onClick={addMoreRow}
// //                     disabled={!fileName || !pDate}
// //                   >
// //                     {t("text.add", "Add")}
// //                   </Button>
// //                 </Grid>
// //               </Grid>

// //               {tableData.length > 0 && (
// //                 <Grid
// //                   item
// //                   xs={12}
// //                   sx={{ marginTop: "15px", overflowX: "auto" }}
// //                 >
// //                   <Table
// //                     style={{
// //                       borderCollapse: "collapse",
// //                       width: "100%",
// //                       border: "1px solid #ddd",
// //                     }}
// //                     size="small"
// //                   >
// //                     <thead style={{ backgroundColor: "#e0e0e0" }}>
// //                       <tr>
// //                         <th
// //                           style={{ border: "1px solid #ddd", padding: "8px" }}
// //                         >
// //                           {t("text.Action", "Action")}
// //                         </th>
// //                         <th
// //                           style={{ border: "1px solid #ddd", padding: "8px" }}
// //                         >
// //                           {t("text.PeriodDate", "Period Date")}
// //                         </th>
// //                         <th
// //                           style={{ border: "1px solid #ddd", padding: "8px" }}
// //                         >
// //                           {t("text.Keywords", "Keywords")}
// //                         </th>
// //                         <th
// //                           style={{ border: "1px solid #ddd", padding: "8px" }}
// //                         >
// //                           {t("text.FileName", "File Name")}
// //                         </th>
// //                         <th
// //                           style={{ border: "1px solid #ddd", padding: "8px" }}
// //                         >
// //                           {t("text.PdfFile", "PDF File")}
// //                         </th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {tableData?.map((row: any) => (
// //                         <tr key={row.id}>
// //                           <td
// //                             style={{
// //                               border: "1px solid #ddd",
// //                               padding: "8px",
// //                               textAlign: "center",
// //                             }}
// //                           >
// //                             <DeleteIcon
// //                               style={{ color: "darkred", cursor: "pointer" }}
// //                               onClick={() => removeExtraRow(row.id)}
// //                             />
// //                           </td>
// //                           <td
// //                             style={{
// //                               border: "1px solid #ddd",
// //                               padding: "8px",
// //                               textAlign: "center",
// //                             }}
// //                           >
// //                             {row.pDate
// //                               ? moment(row.pDate).format("DD-MM-YYYY")
// //                               : "-"}
// //                           </td>
// //                           <td
// //                             style={{ border: "1px solid #ddd", padding: "8px" }}
// //                           >
// //                             {row.keywords || "-"}
// //                           </td>
// //                           <td
// //                             style={{ border: "1px solid #ddd", padding: "8px" }}
// //                           >
// //                             {row.pdfName}
// //                           </td>
// //                           <td
// //                             style={{
// //                               border: "1px solid #ddd",
// //                               padding: "8px",
// //                               textAlign: "center",
// //                             }}
// //                           >
// //                             {row.pdfView ? (
// //                               <Typography
// //                                 onClick={() => modalOpenHandle1(row.pdfView)}
// //                                 sx={{
// //                                   color: "primary.main",
// //                                   cursor: "pointer",
// //                                   textDecoration: "underline",
// //                                 }}
// //                               >
// //                                 {t("text.Preview", "Preview")}
// //                               </Typography>
// //                             ) : (
// //                               t("text.NoPreview", "No Preview")
// //                             )}
// //                           </td>
// //                         </tr>
// //                       ))}
// //                     </tbody>
// //                   </Table>

// //                   {/* Modal section starts here */}
// //                   <Modal
// //                     open={Opens}
// //                     onClose={handlePanClose1}
// //                     aria-labelledby="modal-title"
// //                   >
// //                     <Box sx={modalStyle}>
// //                       {Img ? (
// //                         <embed
// //                           src={Img}
// //                           type="application/pdf"
// //                           style={{
// //                             width: "100%",
// //                             height: "100%",
// //                             minHeight: "500px",
// //                           }}
// //                         />
// //                       ) : (
// //                         <Box sx={{ display: "flex", justifyContent: "center" }}>
// //                           <img
// //                             src={nopdf}
// //                             alt="No PDF"
// //                             style={{ maxWidth: "80%" }}
// //                           />
// //                         </Box>
// //                       )}
// //                     </Box>
// //                   </Modal>
// //                   {/* Modal section ends here */}
// //                 </Grid>
// //               )}

// //               <Grid
// //                 item
// //                 xs={12}
// //                 container
// //                 spacing={2}
// //                 justifyContent="center"
// //                 style={{ marginTop: "20px" }}
// //               >
// //                 <Grid item xs={12} sm={4} md={3}>
// //                   <Button
// //                     type="submit"
// //                     variant="contained"
// //                     fullWidth
// //                     style={{
// //                       backgroundColor: `var(--header-background)`,
// //                       color: "white",
// //                     }}
// //                     disabled={loader}
// //                   >
// //                     {t("text.save", "Save")}
// //                   </Button>
// //                 </Grid>
// //                 <Grid item xs={12} sm={4} md={3}>
// //                   <Button
// //                     type="button"
// //                     variant="contained"
// //                     fullWidth
// //                     style={{ backgroundColor: "#F43F5E", color: "white" }}
// //                     onClick={handleReset}
// //                   >
// //                     {t("text.reset", "Reset")}
// //                   </Button>
// //                 </Grid>
// //               </Grid>
// //             </Grid>
// //           </form>
// //         </CardContent>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DocumentEntryAdd;


// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Modal,
//   Box,
//   Table,
//   CircularProgress,
//   LinearProgress,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import nopdf from "../../../assets/images/nopdf.png";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import AiIcon from "@mui/icons-material/Psychology";
// import moment from "moment";
// import logo from "../../../assets/images/qq.png";
// import { getSecureDevId } from "../../../utils/storageHelpers";
// import { getUserData } from "../../../utils/userDataHelpers";
// const modalStyle = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "80vw",
//   height: "85vh",
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: "10px",
//   overflowY: "auto",
// };

// type Props = {};
// interface SelectOption {
//   value: string | number;
//   label: string;
// }

// const documentContentKeywords: Record<
//   string,
//   { keywords: string[]; typeLabel: string; threshold: number; regex?: RegExp[] }
// > = {
//   FLEET_VEHICLE_REPORT: {
//     keywords: [
//       "vehicle data",
//       "vehicle no",
//       "vehicle type",
//       "time consumption",
//       "fuel consumpt",
//       "tipper",
//       "dumper",
//       "loader",
//       "skid steer",
//       "tata",
//       "leyland",
//       "truck",
//       "hrs",
//       "mins",
//       "sec",
//       "mt",
//     ],
//     regex: [
//       /[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i,
//       /CH\.?NO\.?\s?\d+/i,
//     ],
//     typeLabel: "Fleet Report / Vehicle Data",
//     threshold: 4,
//   },
//   RESUME: {
//     keywords: [
//       "resume",
//       "cv",
//       "curriculum vitae",
//       "experience",
//       "education",
//       "skills",
//       "objective",
//       "summary",
//       "references",
//       "career",
//       "employment history",
//       "qualification",
//     ],
//     typeLabel: "Resume/CV",
//     threshold: 2,
//   },
//   INVOICE: {
//     keywords: [
//       "invoice",
//       "bill",
//       "receipt",
//       "amount due",
//       "invoice #",
//       "invoice number",
//       "bill to",
//       "ship to",
//       "item",
//       "quantity",
//       "price",
//       "total",
//       "tax",
//       "vat",
//       "payment terms",
//     ],
//     typeLabel: "Invoice/Bill",
//     threshold: 2,
//   },
//   LETTER: {
//     keywords: [
//       "dear",
//       "sincerely",
//       "yours faithfully",
//       "regards",
//       "letter",
//       "correspondence",
//       "enclosed",
//       "subject:",
//       "to whom it may concern",
//     ],
//     typeLabel: "Letter/Correspondence",
//     threshold: 2,
//   },
//   NEWS_ARTICLE: {
//     keywords: [
//       "news",
//       "article",
//       "headline",
//       "byline",
//       "published",
//       "edition",
//       "column",
//       "editorial",
//       "reporter",
//       "source",
//       "dateline",
//       "breaking news",
//       "journal",
//     ],
//     typeLabel: "News Article/Publication",
//     threshold: 2,
//   },
//   AGREEMENT: {
//     keywords: [
//       "agreement",
//       "contract",
//       "terms and conditions",
//       "party a",
//       "party b",
//       "whereas",
//       "heretofore",
//       "witnesseth",
//       "binding",
//       "legal",
//       "nda",
//       "memorandum of understanding",
//     ],
//     typeLabel: "Agreement/Contract",
//     threshold: 2,
//   },
//   REPORT: {
//     keywords: [
//       "report",
//       "summary",
//       "analysis",
//       "findings",
//       "conclusion",
//       "executive summary",
//       "introduction",
//       "methodology",
//       "research",
//       "study",
//       "annual report",
//     ],
//     typeLabel: "General Report/Summary",
//     threshold: 2,
//   },
//   FORM: {
//     keywords: [
//       "form",
//       "application",
//       "please fill",
//       "submit",
//       "signature",
//       "date of birth",
//       "personal details",
//       "declaration",
//     ],
//     typeLabel: "Form/Application",
//     threshold: 2,
//   },
//   PRESENTATION: {
//     keywords: [
//       "presentation",
//       "slides",
//       "powerpoint",
//       "keynote",
//       "deck",
//       "slide deck",
//     ],
//     typeLabel: "Presentation",
//     threshold: 1,
//   },
//   SPREADSHEET: {
//     keywords: [
//       "spreadsheet",
//       "excel",
//       "sheet",
//       "workbook",
//       "data",
//       "table",
//       "csv",
//     ],
//     typeLabel: "Spreadsheet/Data",
//     threshold: 1,
//   },
// };

// const simulateAIDocumentTypeDetection = async (
//   _base64Pdf: string,
//   currentFileName: string,
//   t: (key: string, defaultValue?: string) => string,
// ): Promise<string | null> => {
//   return new Promise((resolve) => {
//     const contentToAnalyze = currentFileName
//       .toLowerCase()
//       .replace(/[_-]/g, " ");
//     setTimeout(() => {
//       let detectedTypeLabel: string | null = null;
//       let bestMatchScore = 0;
//       let bestMatchKey: string | null = null;

//       for (const docKey in documentContentKeywords) {
//         const { keywords, threshold, regex } = documentContentKeywords[docKey];
//         let currentScore = 0;
//         if (regex && regex.length > 0) {
//           for (const r of regex) {
//             if (r.test(contentToAnalyze)) {
//               currentScore += 3;
//               break;
//             }
//           }
//         }
//         for (const keyword of keywords) {
//           if (contentToAnalyze.includes(keyword)) {
//             currentScore++;
//             if (
//               docKey
//                 .toLowerCase()
//                 .replace(/_/g, " ")
//                 .includes(keyword.split(" ")[0])
//             ) {
//               currentScore += 1;
//             }
//           }
//         }
//         if (currentScore >= threshold && currentScore > bestMatchScore) {
//           bestMatchScore = currentScore;
//           bestMatchKey = docKey;
//         }
//       }

//       if (bestMatchKey) {
//         detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
//         if (
//           bestMatchKey === "FLEET_VEHICLE_REPORT" &&
//           contentToAnalyze.includes("fuel consum")
//         ) {
//           detectedTypeLabel = t(
//             "text.aiFleetFuelReport",
//             "Fleet Report / Vehicle Fuel Data",
//           );
//         }
//       } else {
//         if (currentFileName.toLowerCase().endsWith(".pdf")) {
//           detectedTypeLabel = t("text.aiGenericDocument", "Generic Document");
//         }
//       }
//       resolve(detectedTypeLabel);
//     }, 1500);
//   });
// };
// const isValidFileType = (file: File): boolean => {
//   // Only allow PDF MIME types
//   const allowedMimeTypes = [
//     "application/pdf",
//   ];

//   // Only allow PDF extensions
//   const allowedExtensions = [".pdf"];

//   // Get the file name
//   const fileName = file.name.toLowerCase();

//   // Check if the file extension is .pdf
//   const fileExtension = fileName.substring(fileName.lastIndexOf("."));
//   if (!allowedExtensions.includes(fileExtension)) {
//     console.log("Rejected: Invalid file extension");
//     return false;
//   }

//   // Check if MIME type is allowed (only PDF)
//   if (!allowedMimeTypes.includes(file.type)) {
//     console.log("Rejected: Invalid MIME type");
//     return false;
//   }

//   // Check for dangerous double extensions (like .pdf.exe or .pdf.bat)
//   // But allow legitimate multiple dots in filename like "Maximum.fine.Payer.pdf"
//   const fileNameParts = fileName.split('.');

//   // If there are more than 2 parts (multiple dots)
//   if (fileNameParts.length > 2) {
//     // Check if the second last part looks like a dangerous extension
//     const secondLastPart = fileNameParts[fileNameParts.length - 2];

//     // List of dangerous extensions that should never appear in the middle
//     const dangerousExtensions = ['exe', 'bat', 'cmd', 'sh', 'msi', 'dll', 'vbs', 'js', 'jar', 'py', 'rb', 'php', 'asp'];

//     // If the second last part is a dangerous extension, reject
//     if (dangerousExtensions.includes(secondLastPart)) {
//       console.log("Rejected: Dangerous double extension detected");
//       return false;
//     }

//     // Also check if the second last part looks like an extension but is actually a word
//     // For example: "file.txt.pdf" should be rejected, but "Maximum.fine.Payer.pdf" should be accepted
//     // We'll do a basic check - if the second last part is longer than 5 chars, it's probably a word
//     if (secondLastPart.length <= 5 && /^[a-zA-Z0-9]+$/.test(secondLastPart)) {
//       // It might be an extension, but we need to check if it's a common word
//       const commonWords = ['fine', 'payer', 'file', 'name', 'test', 'data', 'info', 'main', 'part', 'draft', 'final'];
//       if (!commonWords.includes(secondLastPart)) {
//         console.log("Rejected: Suspicious double extension pattern");
//         return false;
//       }
//     }
//   }

//   // Additional check for executable files disguised as PDFs
//   if (
//     file.type === "application/x-msdownload" ||
//     file.type === "application/x-dosexec" ||
//     file.type === "application/x-executable"
//   ) {
//     console.log("Rejected: Executable file detected");
//     return false;
//   }

//   return true;
// };

// const DocumentEntryAdd = (props: Props) => {
//   const { i18n, t }: any = useTranslation();
//   const getEmpIdFromUser = () => {
//     const data = getUserData();
//     return data && data.length > 0
//       ? data[0]?.userdetail[0]?.empId
//       : null;
//   };
//   const userData = JSON.parse(localStorage.getItem("userdetail") || "[]");
//   const empIdFromStorage = userData[0]?.empId;
//   const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
//   const [Subject, setSubject] = useState<SelectOption[]>([]);
//   const [Division, setDivision] = useState<SelectOption[]>([]);
//   const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]); // New State
//   const today = moment().format("YYYY-MM-DD");
//   const [tableData, setTableData] = useState<any[]>([]);
//   const [pDate, setPDate] = useState(today || "");
//   const [keywords, setKeywords] = useState("");
//   const [fileName, setfileName] = useState("");
//   const [pdfView, setPdfView] = useState("");
//   const [loader, setLoader] = useState(false);
//   const [maxFileNo, setMaxFileNo] = useState("");
//   const [isDetectingAttachmentType, setIsDetectingAttachmentType] =
//     useState(false);
//   const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] =
//     useState<string | null>(null);
//   const [Opens, setOpen] = React.useState(false);
//   const [Img, setImg] = useState<string>("");
//   const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
//   const [originalExtension, setOriginalExtension] = useState("");

//   const handlePanClose1 = () => setOpen(false);
//   const modalOpenHandle1 = (previewUrl: string) => {
//     setOpen(true);
//     setImg(previewUrl);
//   };
//   const devId = getSecureDevId();
//   const initialDivisionId = devId === null || devId === 0 ? "" : String(devId);

//   useEffect(() => {
//     getFileType();
//     getSubject();
//     getDivision();
//     getSubDepartment(); // Initial Load
//     getMaxFileNumber();
//     getEmployeeDetails();
//   }, []);

//   const getMaxFileNumber = async () => {
//     try {
//       const response = await axios.get(
//         HOST_URL.HOST_URL2 + `DocMangr/GetFileNoMax`,
//       );
//       const fileNo = response.data.data[0].fileNo;
//       setMaxFileNo(fileNo);
//       formik.setFieldValue("fileNo", fileNo);
//     } catch (error) {
//       toast.error(t("text.ErrorFetchingMaxFileNo"));
//     }
//   };

//   const getEmployeeDetails = async () => {
//     try {
//       const empId = getEmpIdFromUser(); // 🔥 encrypted se aa raha

//       if (!empId) return;

//       const collectData = {
//         empid: empId,
//         userId: "-1",
//         empName: "",
//         empMobileNo: "",
//         empPincode: 0,
//         roleId: "-1",
//         empDesignationId: -1,
//         empDeptId: -1,
//         empStateId: -1,
//         empCountryID: -1,
//         empCityId: -1
//       };

//       const res = await axios.post(
//         HOST_URL.HOST_URL + "EmpMaster/GetEmpmaster",
//         collectData
//       );

//       if (res.data.isSuccess && res.data.data.length > 0) {
//         const emp = res.data.data[0];

//         // // ✅ FINAL SETTING
//         // formik.setFieldValue("user_Id", emp.empid);       // 🔥 empId → user_Id
//         // formik.setFieldValue("authPersn", emp.empName);   // 🔥 empName → authPersn
//         // ✅ Set user_Id as number, not string
//         formik.setFieldValue("user_Id", emp.empid ? parseInt(emp.empid) : null);
//         formik.setFieldValue("authPersn", emp.empName || "");
//       }
//     } catch (error) {
//       console.error("Employee fetch error:", error);
//     }
//   };

//   const getFileType = () => {
//     const collectData = { docID: -1, parentDocId: -1, userId: "" };
//     axios
//       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] =
//           res?.data?.data?.map((item: any) => ({
//             label: item.doc_Name,
//             value: String(item.docID),
//           })) || [];
//         setTypeOption(arr);
//       });
//   };

//   const getSubject = () => {
//     const collectData = { sID: -1 };
//     axios
//       .post(
//         HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
//         collectData,
//       )
//       .then((res) => {
//         const arr: SelectOption[] =
//           res.data.data.map((item: any) => ({
//             label: item.subject,
//             value: String(item.sId),
//           })) || [];
//         setSubject(arr);
//       });
//   };

//   const getDivision = () => {
//     const collectData = {
//       id: initialDivisionId === "" ? -1 : initialDivisionId,
//       nodeID: -1,
//       titleID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] =
//           res.data.data.map((item: any) => ({
//             label: item.name,
//             value: String(item.id),
//           })) || [];
//         setDivision(arr);
//       });
//   };

//   // New function to get Sub-Departments
//   const getSubDepartment = (deptId: number = -1) => {
//     const collectData = { subDeptID: -1, deptID: deptId };
//     axios
//       .post(
//         HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
//         collectData,
//       )
//       .then((res) => {
//         const arr: SelectOption[] =
//           res.data.data.map((item: any) => ({
//             label: item.subDeptName,
//             value: String(item.subDeptID),
//           })) || [];
//         setSubDepartments(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching sub departments:", error);
//       });
//   };

//   let navigate = useNavigate();

//   const validationSchema = Yup.object({
//     fileNo: Yup.string().required(t("text.reqFileNo", "File No is required")),
//     subsubjId: Yup.string()
//       .nullable()
//       .required(t("text.reqsubsubjId", "Subject is required")),
//     divisionid: Yup.string()
//       .nullable()
//       .required(t("text.reqdivisionid", "Division is required")),
//     // subDeptID: Yup.string()
//     //   .nullable()
//     //   .required(t("text.reqSubDept", "Sub Department is required")), // Added validation
//     fileTypId: Yup.string()
//       .nullable()
//       .required(t("text.reqfileTypeID", "File Type is required")),
//     synopsis: Yup.string().required(
//       t("text.reqFileName", "File Name/Synopsis is required"),
//     ),
//     member_DocFiles: Yup.array()
//       .min(1, t("text.reqAttachment", "At least one attachment is required"))
//       .required(t("text.reqAttachment", "Attachment is required")),
//   });

//   const formik: any = useFormik({
//     initialValues: {
//       fileNo: "",
//       fileDef: "",
//       synopsis: "",
//       fDate: today || "",
//       subsubjId: null as string | null,
//       fileTypId: null as string | null,
//       createdate: today,
//       // user_Id: "",
//       user_Id: null as number | null,
//       authPersn: "",
//       perFr: today || "",
//       perUt: today || "",
//       member_DocFiles: [] as any[],
//       divisionid: initialDivisionId === "" ? null : String(initialDivisionId),
//       // subDeptID: "", // Added to initial values
//       subDeptID: null as string | null,
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       const submissionValues = { ...values, member_DocFiles: tableData };
//       if (
//         !submissionValues.member_DocFiles ||
//         submissionValues.member_DocFiles.length === 0
//       ) {
//         toast.error(t("text.reqAttachment"));
//         return;
//       }
//       setLoader(true);
//       try {
//         const response = await axios.post(
//           HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
//           submissionValues,
//         );
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//           setLoader(false);
//           setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
//         } else {
//           toast.error(response.data.mesg);
//           setLoader(false);
//         }
//       } catch (error) {
//         toast.error(t("text.ErrorSubmittingForm"));
//         setLoader(false);
//       }
//     },
//   });

//   //   const onTransctionChange = async (
//   //     event: React.ChangeEvent<HTMLInputElement>,
//   //   ) => {
//   //     if (event.target.files && event.target.files[0]) {
//   //       const file = event.target.files[0];
//   //      if (!isValidFileType(file)) {
//   //   toast.error(
//   //     t("text.invalidFileType", "Only PDF files are allowed")
//   //   );
//   //   event.target.value = ""; // Reset the file input
//   //   return;
//   // }
//   //       const fileURL = URL.createObjectURL(file);
//   //       const currentFileName = file.name;
//   //       const extIndex = currentFileName.lastIndexOf(".");
//   //       const withoutExt =
//   //         extIndex !== -1
//   //           ? currentFileName.substring(0, extIndex)
//   //           : currentFileName;
//   //       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : "";
//   //       setPdfView(fileURL);
//   //       setfileName(currentFileName);
//   //       setFileNameWithoutExt(withoutExt);
//   //       setOriginalExtension(ext);
//   //       setIsDetectingAttachmentType(true);
//   //       try {
//   //         const detectedLabel = await simulateAIDocumentTypeDetection(
//   //           "",
//   //           currentFileName,
//   //           t,
//   //         );
//   //         setCurrentAttachmentAiSuggestion(detectedLabel);
//   //       } finally {
//   //         setIsDetectingAttachmentType(false);
//   //       }
//   //     }
//   //   };
//   const onTransctionChange = async (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     if (event.target.files && event.target.files[0]) {
//       const file = event.target.files[0];
//       const fileName = file.name;

//       // First validate the file
//       if (!isValidFileType(file)) {
//         toast.error(
//           t("text.invalidFileType", "Only valid PDF files are allowed")
//         );
//         event.target.value = ""; // Reset the file input
//         return;
//       }

//       const fileURL = URL.createObjectURL(file);
//       const extIndex = fileName.lastIndexOf(".");
//       const withoutExt =
//         extIndex !== -1
//           ? fileName.substring(0, extIndex)
//           : fileName;
//       const ext = extIndex !== -1 ? fileName.substring(extIndex) : "";

//       // Ensure extension is .pdf
//       if (ext.toLowerCase() !== ".pdf") {
//         toast.error(t("text.onlyPdfAllowed", "Only PDF files are allowed"));
//         event.target.value = "";
//         return;
//       }

//       setPdfView(fileURL);
//       setfileName(fileName);
//       setFileNameWithoutExt(withoutExt);
//       setOriginalExtension(ext);
//       setCurrentAttachmentAiSuggestion(null);
//       setIsDetectingAttachmentType(true);

//       try {
//         const detectedLabel = await simulateAIDocumentTypeDetection(
//           "",
//           fileName,
//           t
//         );
//         setCurrentAttachmentAiSuggestion(detectedLabel);
//         if (detectedLabel) {
//           toast.info(
//             t(
//               "text.aiAttachmentCategorySuggestion",
//               `AI suggests category: ${detectedLabel}`
//             ),
//             { autoClose: 3500 }
//           );
//         } else {
//           toast.info(
//             t(
//               "text.aiNoSpecificCategoryForAttachment",
//               "AI couldn't suggest a specific category."
//             ),
//             { autoClose: 3000 }
//           );
//         }
//       } catch (aiError) {
//         console.error("AI attachment category detection error:", aiError);
//         toast.error(t("text.aiDetectionError"));
//       } finally {
//         setIsDetectingAttachmentType(false);
//       }
//     } else {
//       // When no file is selected (user cancelled), reset everything
//       setfileName("");
//       setPdfView("");
//       setFileNameWithoutExt("");
//       setOriginalExtension("");
//       setIsDetectingAttachmentType(false);
//       setCurrentAttachmentAiSuggestion(null);

//       // Ensure the input is cleared
//       event.target.value = "";
//     }
//   };
//   const addMoreRow = () => {
//     if (!fileName || !pDate) {
//       toast.warn(t("text.PleaseFillAttachmentDetails"));
//       return;
//     }

//     const newRow = {
//       id: Date.now(),
//       pdFid: -1,
//       pdfName: fileName,
//       docMid: -1,
//       keywords: keywords,
//       subFtype: "",
//       pDate: pDate,
//       isMain: "",
//       entryDate: moment().format("YYYY-MM-DD"),
//       user_id: -1,
//       pdfPath: "",
//       pdfView: pdfView,
//       srn: -1,
//       isDelete: false,
//     };

//     const updatedTableData = [...tableData, newRow];
//     setTableData(updatedTableData);
//     formik.setFieldValue("member_DocFiles", updatedTableData);

//     // Reset all file-related states
//     setfileName("");
//     setPdfView("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setCurrentAttachmentAiSuggestion(null);

//     // Reset the file input element
//     const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };

//   const removeExtraRow = (id: any) => {
//     const updatedTableData = tableData.filter((row) => row.id !== id);
//     setTableData(updatedTableData);
//     formik.setFieldValue("member_DocFiles", updatedTableData);
//   };

//   const back = useNavigate();
//   const getAutocompleteValue = (
//     options: SelectOption[],
//     formikValue: string | null | number,
//   ): SelectOption | null => {
//     if (formikValue === null || formikValue === undefined) return null;
//     return (
//       options.find((option) => String(option.value) === String(formikValue)) ||
//       null
//     );
//   };

//   const handleReset = () => {
//     formik.resetForm();
//     setTableData([]);
//     setPDate(today || "");
//     setKeywords("");
//     setfileName("");
//     setPdfView("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setCurrentAttachmentAiSuggestion(null);
//     setIsDetectingAttachmentType(false);

//     // Reset max file number
//     getMaxFileNumber();

//     // Reset division to initial value
//     formik.setFieldValue(
//       "divisionid",
//       initialDivisionId === "" ? null : String(initialDivisionId),
//     );
//     // ✅ Reset subDeptID to null
//     formik.setFieldValue("subDeptID", null);
//     // Reset the file input element
//     const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
//     if (fileInput) {
//       fileInput.value = "";
//     }

//     // Reset any other file inputs if they exist
//     const fileInputs = document.querySelectorAll('input[type="file"]');
//     fileInputs.forEach((input: any) => {
//       input.value = "";
//     });
//   };
//   return (
//     <div>
//       <ToastApp />
//       {loader && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             backgroundColor: "rgba(255, 255, 255, 0.7)",
//             zIndex: (theme) => theme.zIndex.drawer + 50,
//           }}
//         >
//           {" "}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               padding: 4,
//               backgroundColor: "rgba(255,255,255,0.95)",
//               borderRadius: "12px",
//               boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
//               border: "1px solid rgba(255, 255, 255, 0.18)",
//             }}
//           >
//             {" "}
//             <img
//               src={logo}
//               alt="Loading..."
//               style={{ width: "120px", height: "auto", marginBottom: "24px" }}
//             />{" "}
//             <LinearProgress
//               color="primary"
//               sx={{ width: "200px", height: "8px", borderRadius: "4px" }}
//             />{" "}
//             <Typography
//               variant="subtitle1"
//               sx={{ marginTop: 2, color: "text.secondary" }}
//             >
//               {" "}
//               {t("text.processing", "Processing, please wait...")}{" "}
//             </Typography>{" "}
//           </Box>{" "}
//         </Box>
//       )}

//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "3vh",
//           filter: loader ? "blur(5px)" : "none",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {" "}
//             {t("text.DocumentEntryAdd", "Document Entry Add")}{" "}
//           </Typography>
//           <Grid item sm={4} xs={12} style={{ marginTop: "-40px" }}>
//             {" "}
//             <Button
//               type="button"
//               onClick={() => back(-1)}
//               variant="contained"
//               style={{
//                 backgroundColor: `var(--header-background)`,
//                 minWidth: "40px",
//               }}
//             >
//               {" "}
//               <ArrowBackSharpIcon />{" "}
//             </Button>{" "}
//           </Grid>
//           <Divider style={{ marginTop: "10px", marginBottom: "20px" }} />

//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={2}>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileNo"
//                   name="fileNo"
//                   label={
//                     <span>
//                       {t("text.EnterFileNo", "File No")}{" "}
//                       <span
//                         style={{
//                           color:
//                             formik.values.fileNo && !formik.errors.fileNo
//                               ? "green"
//                               : "red",
//                         }}
//                       >
//                         *
//                       </span>
//                     </span>
//                   }
//                   value={formik.values.fileNo}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.fileNo && Boolean(formik.errors.fileNo)}
//                   helperText={
//                     formik.touched.fileNo && (formik.errors.fileNo as string)
//                   }
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="synopsis"
//                   name="synopsis"
//                   label={
//                     <span>
//                       {t("text.FileName", "File Name/Synopsis")}{" "}
//                       <span
//                         style={{
//                           color:
//                             formik.values.synopsis && !formik.errors.synopsis
//                               ? "green"
//                               : "red",
//                         }}
//                       >
//                         *
//                       </span>
//                     </span>
//                   }
//                   value={formik.values.synopsis}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={
//                     formik.touched.synopsis && Boolean(formik.errors.synopsis)
//                   }
//                   helperText={
//                     formik.touched.synopsis &&
//                     (formik.errors.synopsis as string)
//                   }
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileDef"
//                   name="fileDef"
//                   label={t("text.EnterFileDef", "File Definition")}
//                   value={formik.values.fileDef}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   size="small"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perFr"
//                   name="perFr"
//                   label={t("text.EnterPeriodFileFrom", "Period From")}
//                   value={formik.values.perFr}
//                   onChange={formik.handleChange}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perUt"
//                   name="perUt"
//                   label={t("text.EnterPeriodFileUpto", "Period Upto")}
//                   value={formik.values.perUt}
//                   onChange={formik.handleChange}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="authPersn"
//                   name="authPersn"
//                   label={t(
//                     "text.EnterAuthenticatePerson",
//                     "Authenticate Person",
//                   )}
//                   value={formik.values.authPersn}
//                   onChange={formik.handleChange}
//                   size="small"
//                   fullWidth
//                   disabled
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fDate"
//                   name="fDate"
//                   label={t("text.EnterFileDate", "File Date")}
//                   value={formik.values.fDate}
//                   onChange={formik.handleChange}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                 />
//               </Grid>

//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="fileTypId"
//                   options={TypeOption}
//                   value={getAutocompleteValue(
//                     TypeOption,
//                     formik.values.fileTypId,
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "fileTypId",
//                       newValue ? String(newValue.value) : null,
//                     );
//                   }}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectFile", "Select File Type")}{" "}
//                           <span
//                             style={{
//                               color: formik.values.fileTypId && !formik.errors.fileTypId
//                                 ? "green"
//                                 : "red"
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.fileTypId &&
//                         Boolean(formik.errors.fileTypId)
//                       }
//                       helperText={
//                         formik.touched.fileTypId &&
//                         (formik.errors.fileTypId as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="subsubjId"
//                   options={Subject}
//                   value={getAutocompleteValue(Subject, formik.values.subsubjId)}
//                   getOptionLabel={(option) => option.label}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "subsubjId",
//                       newValue ? String(newValue.value) : null,
//                     );
//                   }}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       // label={
//                       //   <span>
//                       //     {t("text.SelectSubject", "Select Subject")} *
//                       //   </span>
//                       // }
//                       label={
//                         <span>
//                           {t("text.SelectSubject", "Select Subject")}{" "}
//                           <span
//                             style={{
//                               color: formik.values.subsubjId && !formik.errors.subsubjId
//                                 ? "green"
//                                 : "red"
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.subsubjId &&
//                         Boolean(formik.errors.subsubjId)
//                       }
//                       helperText={
//                         formik.touched.subsubjId &&
//                         (formik.errors.subsubjId as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>

//               {/* Division/Department Field */}
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="divisionid"
//                   options={Division}
//                   value={getAutocompleteValue(
//                     Division,
//                     formik.values.divisionid,
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "divisionid",
//                       newValue ? String(newValue.value) : null,
//                     );
//                     getSubDepartment(Number(newValue?.value || -1));
//                   }}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}

//                       label={
//                         <span>
//                           {t("text.SelectDepartment", "Select Division/Department")}{" "}
//                           <span
//                             style={{
//                               color: formik.values.divisionid && !formik.errors.divisionid
//                                 ? "green"  
//                                 : "red"   
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.divisionid &&
//                         Boolean(formik.errors.divisionid)
//                       }
//                       helperText={
//                         formik.touched.divisionid &&
//                         (formik.errors.divisionid as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>

//               {/* New Sub Department Field (Added) */}
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="subDeptID"
//                   options={subDepartments}
//                   value={getAutocompleteValue(
//                     subDepartments,
//                     formik.values.subDeptID,
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) =>
//                     String(option.value) === String(value?.value)
//                   }
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "subDeptID",
//                       newValue ? String(newValue.value) : null,
//                     );
//                   }}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         t("text.SelectSubDept", "Select Sub Department")
//                         // <span>
//                         //   {t("text.SelectSubDept", "Select Sub Department")}{" "}
//                         //   <span
//                         //     style={{
//                         //       color:
//                         //         formik.values.subDeptID &&
//                         //         !formik.errors.subDeptID
//                         //           ? "green"
//                         //           : "red",
//                         //     }}
//                         //   >
//                         //     *
//                         //   </span>
//                         // </span>
//                       }
//                       error={
//                         formik.touched.subDeptID &&
//                         Boolean(formik.errors.subDeptID)
//                       }
//                       helperText={
//                         formik.touched.subDeptID &&
//                         (formik.errors.subDeptID as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Divider sx={{ marginY: 2 }}>
//                   <Typography variant="subtitle1">
//                     {t("text.Attachments", "Attachments")}*
//                   </Typography>
//                 </Divider>
//               </Grid>
//               <Grid item container xs={12} spacing={2} alignItems="flex-start">
//                 <Grid item xs={12} lg={2.5}>
//                   <TextField
//                     label={t("text.PeriodDate", "Period Date")}
//                     value={pDate}
//                     onChange={(e: any) => setPDate(e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     size="small"
//                     type="date"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={2}>
//                   <TextField
//                     label={t("text.Keywords", "Keywords")}
//                     value={keywords}
//                     onChange={(e: any) => setKeywords(e.target.value)}
//                     size="small"
//                     fullWidth
//                   />
//                 </Grid>


//                 <Grid item xs={12} lg={3}>
//                   <TextField
//                     id="pdf_attach_file_input"
//                     name="pdf_attach_input"
//                     label={t("text.AttachedFile", "Attach File")}
//                     onChange={onTransctionChange}
//                     size="small"
//                     type="file"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputLabelProps={{ shrink: true }}
//                     inputProps={{
//                       accept: ".pdf,application/pdf" // Only accept PDF files
//                     }}
//                   />
//                   <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
//                     {t("text.allowedFileTypes", "Only PDF files are allowed")}
//                   </Typography>
//                   {isDetectingAttachmentType && fileName && (
//                     <Box sx={{ width: '100%', mt: 0.5 }}>
//                       <LinearProgress variant="indeterminate" />
//                       <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
//                         {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
//                       </Typography>
//                     </Box>
//                   )}
//                   {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
//                     <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1 }}>
//                       <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
//                       <Typography variant="caption" component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
//                         {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Grid>


//                 <Grid item xs={12} lg={3}>
//                   <TextField
//                     id="fileName_display"
//                     name="fileName_display"
//                     label={t("text.EnterFileName", "Selected File")}
//                     value={fileNameWithoutExt}
//                     onChange={(e) => {
//                       let input = e.target.value.trim();

//                       // Don't automatically remove dots - they might be part of the name
//                       // Just ensure the final filename will have .pdf extension

//                       const forcedExt = ".pdf";

//                       setFileNameWithoutExt(input);
//                       setOriginalExtension(forcedExt);
//                       setfileName(input + forcedExt);
//                     }}
//                     size="small"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputProps={{
//                       endAdornment: originalExtension ? (
//                         <InputAdornment
//                           position="end"
//                           disableTypography
//                           sx={{
//                             pointerEvents: "none",
//                             userSelect: "none",
//                             color: "green",
//                             fontWeight: "bold"
//                           }}
//                         >
//                           {originalExtension}
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                     InputLabelProps={{
//                       shrink: Boolean(fileNameWithoutExt || originalExtension),
//                     }}
//                     error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
//                     helperText={
//                       fileName && !fileName.toLowerCase().endsWith(".pdf")
//                         ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
//                         : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
//                     }
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={1.5}>
//                   <Button
//                     startIcon={<AddCircleIcon />}
//                     variant="contained"
//                     color="info"
//                     fullWidth
//                     onClick={addMoreRow}
//                     disabled={!fileName || !pDate}
//                   >
//                     {t("text.add", "Add")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               {tableData.length > 0 && (
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{ marginTop: "15px", overflowX: "auto" }}
//                 >
//                   <Table
//                     style={{
//                       borderCollapse: "collapse",
//                       width: "100%",
//                       border: "1px solid #ddd",
//                     }}
//                     size="small"
//                   >
//                     <thead style={{ backgroundColor: "#e0e0e0" }}>
//                       <tr>
//                         <th
//                           style={{ border: "1px solid #ddd", padding: "8px" }}
//                         >
//                           {t("text.Action", "Action")}
//                         </th>
//                         <th
//                           style={{ border: "1px solid #ddd", padding: "8px" }}
//                         >
//                           {t("text.PeriodDate", "Period Date")}
//                         </th>
//                         <th
//                           style={{ border: "1px solid #ddd", padding: "8px" }}
//                         >
//                           {t("text.Keywords", "Keywords")}
//                         </th>
//                         <th
//                           style={{ border: "1px solid #ddd", padding: "8px" }}
//                         >
//                           {t("text.FileName", "File Name")}
//                         </th>
//                         <th
//                           style={{ border: "1px solid #ddd", padding: "8px" }}
//                         >
//                           {t("text.PdfFile", "PDF File")}
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData?.map((row: any) => (
//                         <tr key={row.id}>
//                           <td
//                             style={{
//                               border: "1px solid #ddd",
//                               padding: "8px",
//                               textAlign: "center",
//                             }}
//                           >
//                             <DeleteIcon
//                               style={{ color: "darkred", cursor: "pointer" }}
//                               onClick={() => removeExtraRow(row.id)}
//                             />
//                           </td>
//                           <td
//                             style={{
//                               border: "1px solid #ddd",
//                               padding: "8px",
//                               textAlign: "center",
//                             }}
//                           >
//                             {row.pDate
//                               ? moment(row.pDate).format("DD-MM-YYYY")
//                               : "-"}
//                           </td>
//                           <td
//                             style={{ border: "1px solid #ddd", padding: "8px" }}
//                           >
//                             {row.keywords || "-"}
//                           </td>
//                           <td
//                             style={{ border: "1px solid #ddd", padding: "8px" }}
//                           >
//                             {row.pdfName}
//                           </td>
//                           <td
//                             style={{
//                               border: "1px solid #ddd",
//                               padding: "8px",
//                               textAlign: "center",
//                             }}
//                           >
//                             {row.pdfView ? (
//                               <Typography
//                                 onClick={() => modalOpenHandle1(row.pdfView)}
//                                 sx={{
//                                   color: "primary.main",
//                                   cursor: "pointer",
//                                   textDecoration: "underline",
//                                 }}
//                               >
//                                 {t("text.Preview", "Preview")}
//                               </Typography>
//                             ) : (
//                               t("text.NoPreview", "No Preview")
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>

//                   {/* Modal section starts here */}
//                   <Modal
//                     open={Opens}
//                     onClose={handlePanClose1}
//                     aria-labelledby="modal-title"
//                   >
//                     <Box sx={modalStyle}>
//                       {Img ? (
//                         <embed
//                           src={Img}
//                           type="application/pdf"
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             minHeight: "500px",
//                           }}
//                         />
//                       ) : (
//                         <Box sx={{ display: "flex", justifyContent: "center" }}>
//                           <img
//                             src={nopdf}
//                             alt="No PDF"
//                             style={{ maxWidth: "80%" }}
//                           />
//                         </Box>
//                       )}
//                     </Box>
//                   </Modal>
//                   {/* Modal section ends here */}
//                 </Grid>
//               )}

//               <Grid
//                 item
//                 xs={12}
//                 container
//                 spacing={2}
//                 justifyContent="center"
//                 style={{ marginTop: "20px" }}
//               >
//                 <Grid item xs={12} sm={4} md={3}>
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                     }}
//                     disabled={loader}
//                   >
//                     {t("text.save", "Save")}
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12} sm={4} md={3}>
//                   <Button
//                     type="button"
//                     variant="contained"
//                     fullWidth
//                     style={{ backgroundColor: "#F43F5E", color: "white" }}
//                     onClick={handleReset}
//                   >
//                     {t("text.reset", "Reset")}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default DocumentEntryAdd;



import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Table,
  CircularProgress,
  LinearProgress,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import nopdf from "../../../assets/images/nopdf.png";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AiIcon from "@mui/icons-material/Psychology";
import moment from "moment";
import logo from "../../../assets/images/qq.png";
import { getSecureDevId } from "../../../utils/storageHelpers";
import { getUserData } from "../../../utils/userDataHelpers";
const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "85vh",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  overflowY: "auto",
};

type Props = {};
interface SelectOption {
  value: string | number;
  label: string;
}

const documentContentKeywords: Record<
  string,
  { keywords: string[]; typeLabel: string; threshold: number; regex?: RegExp[] }
> = {
  FLEET_VEHICLE_REPORT: {
    keywords: [
      "vehicle data",
      "vehicle no",
      "vehicle type",
      "time consumption",
      "fuel consumpt",
      "tipper",
      "dumper",
      "loader",
      "skid steer",
      "tata",
      "leyland",
      "truck",
      "hrs",
      "mins",
      "sec",
      "mt",
    ],
    regex: [
      /[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i,
      /CH\.?NO\.?\s?\d+/i,
    ],
    typeLabel: "Fleet Report / Vehicle Data",
    threshold: 4,
  },
  RESUME: {
    keywords: [
      "resume",
      "cv",
      "curriculum vitae",
      "experience",
      "education",
      "skills",
      "objective",
      "summary",
      "references",
      "career",
      "employment history",
      "qualification",
    ],
    typeLabel: "Resume/CV",
    threshold: 2,
  },
  INVOICE: {
    keywords: [
      "invoice",
      "bill",
      "receipt",
      "amount due",
      "invoice #",
      "invoice number",
      "bill to",
      "ship to",
      "item",
      "quantity",
      "price",
      "total",
      "tax",
      "vat",
      "payment terms",
    ],
    typeLabel: "Invoice/Bill",
    threshold: 2,
  },
  LETTER: {
    keywords: [
      "dear",
      "sincerely",
      "yours faithfully",
      "regards",
      "letter",
      "correspondence",
      "enclosed",
      "subject:",
      "to whom it may concern",
    ],
    typeLabel: "Letter/Correspondence",
    threshold: 2,
  },
  NEWS_ARTICLE: {
    keywords: [
      "news",
      "article",
      "headline",
      "byline",
      "published",
      "edition",
      "column",
      "editorial",
      "reporter",
      "source",
      "dateline",
      "breaking news",
      "journal",
    ],
    typeLabel: "News Article/Publication",
    threshold: 2,
  },
  AGREEMENT: {
    keywords: [
      "agreement",
      "contract",
      "terms and conditions",
      "party a",
      "party b",
      "whereas",
      "heretofore",
      "witnesseth",
      "binding",
      "legal",
      "nda",
      "memorandum of understanding",
    ],
    typeLabel: "Agreement/Contract",
    threshold: 2,
  },
  REPORT: {
    keywords: [
      "report",
      "summary",
      "analysis",
      "findings",
      "conclusion",
      "executive summary",
      "introduction",
      "methodology",
      "research",
      "study",
      "annual report",
    ],
    typeLabel: "General Report/Summary",
    threshold: 2,
  },
  FORM: {
    keywords: [
      "form",
      "application",
      "please fill",
      "submit",
      "signature",
      "date of birth",
      "personal details",
      "declaration",
    ],
    typeLabel: "Form/Application",
    threshold: 2,
  },
  PRESENTATION: {
    keywords: [
      "presentation",
      "slides",
      "powerpoint",
      "keynote",
      "deck",
      "slide deck",
    ],
    typeLabel: "Presentation",
    threshold: 1,
  },
  SPREADSHEET: {
    keywords: [
      "spreadsheet",
      "excel",
      "sheet",
      "workbook",
      "data",
      "table",
      "csv",
    ],
    typeLabel: "Spreadsheet/Data",
    threshold: 1,
  },
};

const simulateAIDocumentTypeDetection = async (
  _base64Pdf: string,
  currentFileName: string,
  t: (key: string, defaultValue?: string) => string,
): Promise<string | null> => {
  return new Promise((resolve) => {
    const contentToAnalyze = currentFileName
      .toLowerCase()
      .replace(/[_-]/g, " ");
    setTimeout(() => {
      let detectedTypeLabel: string | null = null;
      let bestMatchScore = 0;
      let bestMatchKey: string | null = null;

      for (const docKey in documentContentKeywords) {
        const { keywords, threshold, regex } = documentContentKeywords[docKey];
        let currentScore = 0;
        if (regex && regex.length > 0) {
          for (const r of regex) {
            if (r.test(contentToAnalyze)) {
              currentScore += 3;
              break;
            }
          }
        }
        for (const keyword of keywords) {
          if (contentToAnalyze.includes(keyword)) {
            currentScore++;
            if (
              docKey
                .toLowerCase()
                .replace(/_/g, " ")
                .includes(keyword.split(" ")[0])
            ) {
              currentScore += 1;
            }
          }
        }
        if (currentScore >= threshold && currentScore > bestMatchScore) {
          bestMatchScore = currentScore;
          bestMatchKey = docKey;
        }
      }

      if (bestMatchKey) {
        detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
        if (
          bestMatchKey === "FLEET_VEHICLE_REPORT" &&
          contentToAnalyze.includes("fuel consum")
        ) {
          detectedTypeLabel = t(
            "text.aiFleetFuelReport",
            "Fleet Report / Vehicle Fuel Data",
          );
        }
      } else {
        if (currentFileName.toLowerCase().endsWith(".pdf")) {
          detectedTypeLabel = t("text.aiGenericDocument", "Generic Document");
        }
      }
      resolve(detectedTypeLabel);
    }, 1500);
  });
};
const isValidFileType = (file: File): boolean => {
  // Only allow PDF MIME types
  const allowedMimeTypes = [
    "application/pdf",
  ];

  // Only allow PDF extensions
  const allowedExtensions = [".pdf"];

  // Get the file name
  const fileName = file.name.toLowerCase();

  // Check if the file extension is .pdf
  const fileExtension = fileName.substring(fileName.lastIndexOf("."));
  if (!allowedExtensions.includes(fileExtension)) {
    console.log("Rejected: Invalid file extension");
    return false;
  }

  // Check if MIME type is allowed (only PDF)
  if (!allowedMimeTypes.includes(file.type)) {
    console.log("Rejected: Invalid MIME type");
    return false;
  }

  // Check for dangerous double extensions (like .pdf.exe or .pdf.bat)
  // But allow legitimate multiple dots in filename like "Maximum.fine.Payer.pdf"
  const fileNameParts = fileName.split('.');

  // If there are more than 2 parts (multiple dots)
  if (fileNameParts.length > 2) {
    // Check if the second last part looks like a dangerous extension
    const secondLastPart = fileNameParts[fileNameParts.length - 2];

    // List of dangerous extensions that should never appear in the middle
    const dangerousExtensions = ['exe', 'bat', 'cmd', 'sh', 'msi', 'dll', 'vbs', 'js', 'jar', 'py', 'rb', 'php', 'asp'];

    // If the second last part is a dangerous extension, reject
    if (dangerousExtensions.includes(secondLastPart)) {
      console.log("Rejected: Dangerous double extension detected");
      return false;
    }

    // Also check if the second last part looks like an extension but is actually a word
    // For example: "file.txt.pdf" should be rejected, but "Maximum.fine.Payer.pdf" should be accepted
    // We'll do a basic check - if the second last part is longer than 5 chars, it's probably a word
    if (secondLastPart.length <= 5 && /^[a-zA-Z0-9]+$/.test(secondLastPart)) {
      // It might be an extension, but we need to check if it's a common word
      const commonWords = ['fine', 'payer', 'file', 'name', 'test', 'data', 'info', 'main', 'part', 'draft', 'final'];
      if (!commonWords.includes(secondLastPart)) {
        console.log("Rejected: Suspicious double extension pattern");
        return false;
      }
    }
  }

  // Additional check for executable files disguised as PDFs
  if (
    file.type === "application/x-msdownload" ||
    file.type === "application/x-dosexec" ||
    file.type === "application/x-executable"
  ) {
    console.log("Rejected: Executable file detected");
    return false;
  }

  return true;
};

const DocumentEntryAdd = (props: Props) => {
  const { i18n, t }: any = useTranslation();
  const getEmpIdFromUser = () => {
    const data = getUserData();
    return data && data.length > 0
      ? data[0]?.userdetail[0]?.empId
      : null;
  };
  const userData = JSON.parse(localStorage.getItem("userdetail") || "[]");
  const empIdFromStorage = userData[0]?.empId;
  const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
  const [Subject, setSubject] = useState<SelectOption[]>([]);
  const [Division, setDivision] = useState<SelectOption[]>([]);
  const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]); // New State
  const today = moment().format("YYYY-MM-DD");
  const [tableData, setTableData] = useState<any[]>([]);
  const [pDate, setPDate] = useState(today || "");
  const [keywords, setKeywords] = useState("");
  const [fileName, setfileName] = useState("");
  const [pdfView, setPdfView] = useState("");
  const [loader, setLoader] = useState(false);
  const [maxFileNo, setMaxFileNo] = useState("");
  const [isDetectingAttachmentType, setIsDetectingAttachmentType] =
    useState(false);
  const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] =
    useState<string | null>(null);
  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState<string>("");
  const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
  const [originalExtension, setOriginalExtension] = useState("");

  const handlePanClose1 = () => setOpen(false);
  const modalOpenHandle1 = (previewUrl: string) => {
    setOpen(true);
    setImg(previewUrl);
  };
  const devId = getSecureDevId();
  const initialDivisionId = devId === null || devId === 0 ? "" : String(devId);

  useEffect(() => {
    getFileType();
    getSubject();
    getDivision();
    getSubDepartment(); // Initial Load
    getMaxFileNumber();
    getEmployeeDetails();
  }, []);

  const getMaxFileNumber = async () => {
    try {
      const response = await axios.get(
        HOST_URL.HOST_URL2 + `DocMangr/GetFileNoMax`,
        {
          params: {
            _t: new Date().getTime()  // Cache busting timestamp
          },
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        }
      );
      const fileNo = response.data.data[0].fileNo;
      setMaxFileNo(fileNo);
      formik.setFieldValue("fileNo", fileNo);
    } catch (error) {
      toast.error(t("text.ErrorFetchingMaxFileNo"));
    }
  };

  const getEmployeeDetails = async () => {
    try {
      const empId = getEmpIdFromUser(); // 🔥 encrypted se aa raha

      if (!empId) return;

      const collectData = {
        empid: empId,
        userId: "-1",
        empName: "",
        empMobileNo: "",
        empPincode: 0,
        roleId: "-1",
        empDesignationId: -1,
        empDeptId: -1,
        empStateId: -1,
        empCountryID: -1,
        empCityId: -1
      };

      const res = await axios.post(
        HOST_URL.HOST_URL + "EmpMaster/GetEmpmaster",
        collectData
      );

      if (res.data.isSuccess && res.data.data.length > 0) {
        const emp = res.data.data[0];

        // // ✅ FINAL SETTING
        // formik.setFieldValue("user_Id", emp.empid);       // 🔥 empId → user_Id
        // formik.setFieldValue("authPersn", emp.empName);   // 🔥 empName → authPersn
        // ✅ Set user_Id as number, not string
        formik.setFieldValue("user_Id", emp.empid ? parseInt(emp.empid) : null);
        formik.setFieldValue("authPersn", emp.empName || "");
      }
    } catch (error) {
      console.error("Employee fetch error:", error);
    }
  };

  const getFileType = () => {
    const collectData = { docID: -1, parentDocId: -1, userId: "" };
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
      .then((res) => {
        const arr: SelectOption[] =
          res?.data?.data?.map((item: any) => ({
            label: item.doc_Name,
            value: String(item.docID),
          })) || [];
        setTypeOption(arr);
      });
  };

  const getSubject = () => {
    const collectData = { sID: -1 };
    axios
      .post(
        HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
        collectData,
      )
      .then((res) => {
        const arr: SelectOption[] =
          res.data.data.map((item: any) => ({
            label: item.subject,
            value: String(item.sId),
          })) || [];
        setSubject(arr);
      });
  };

  const getDivision = () => {
    const collectData = {
      id: initialDivisionId === "" ? -1 : initialDivisionId,
      nodeID: -1,
      titleID: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
      .then((res) => {
        const arr: SelectOption[] =
          res.data.data.map((item: any) => ({
            label: item.name,
            value: String(item.id),
          })) || [];
        setDivision(arr);
      });
  };

  // New function to get Sub-Departments
  const getSubDepartment = (deptId: number = -1) => {
    const collectData = { subDeptID: -1, deptID: deptId };
    axios
      .post(
        HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`,
        collectData,
      )
      .then((res) => {
        const arr: SelectOption[] =
          res.data.data.map((item: any) => ({
            label: item.subDeptName,
            value: String(item.subDeptID),
          })) || [];
        setSubDepartments(arr);
      })
      .catch((error) => {
        console.error("Error fetching sub departments:", error);
      });
  };

  let navigate = useNavigate();

  const validationSchema = Yup.object({
    fileNo: Yup.string().required(t("text.reqFileNo", "File No is required")),
    subsubjId: Yup.string()
      .nullable()
      .required(t("text.reqsubsubjId", "Subject is required")),
    divisionid: Yup.string()
      .nullable()
      .required(t("text.reqdivisionid", "Division is required")),
    // subDeptID: Yup.string()
    //   .nullable()
    //   .required(t("text.reqSubDept", "Sub Department is required")), // Added validation
    fileTypId: Yup.string()
      .nullable()
      .required(t("text.reqfileTypeID", "File Type is required")),
    synopsis: Yup.string().required(
      t("text.reqSynopsis", "Synopsis is required"),
    ),
    member_DocFiles: Yup.array()
      .min(1, t("text.reqAttachment", "At least one attachment is required"))
      .required(t("text.reqAttachment", "Attachment is required")),
  });

  const formik: any = useFormik({
    initialValues: {
      fileNo: "",
      fileDef: "",
      synopsis: "",
      fDate: today || "",
      subsubjId: null as string | null,
      fileTypId: null as string | null,
      createdate: today,
      // user_Id: "",
      user_Id: null as number | null,
      authPersn: "",
      perFr: today || "",
      perUt: today || "",
      member_DocFiles: [] as any[],
      divisionid:null,
     // divisionid: initialDivisionId === "" ? null : String(initialDivisionId),
      // subDeptID: "", // Added to initial values
      subDeptID: null as string | null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const submissionValues = { ...values, member_DocFiles: tableData };
      if (
        !submissionValues.member_DocFiles ||
        submissionValues.member_DocFiles.length === 0
      ) {
        toast.error(t("text.reqAttachment"));
        return;
      }
      setLoader(true);
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
          submissionValues,
        );
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          setLoader(false);
          setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
        } else {
          toast.error(response.data.mesg);
          setLoader(false);
        }
      } catch (error) {
        toast.error(t("text.ErrorSubmittingForm"));
        setLoader(false);
      }
    },
  });

  //   const onTransctionChange = async (
  //     event: React.ChangeEvent<HTMLInputElement>,
  //   ) => {
  //     if (event.target.files && event.target.files[0]) {
  //       const file = event.target.files[0];
  //      if (!isValidFileType(file)) {
  //   toast.error(
  //     t("text.invalidFileType", "Only PDF files are allowed")
  //   );
  //   event.target.value = ""; // Reset the file input
  //   return;
  // }
  //       const fileURL = URL.createObjectURL(file);
  //       const currentFileName = file.name;
  //       const extIndex = currentFileName.lastIndexOf(".");
  //       const withoutExt =
  //         extIndex !== -1
  //           ? currentFileName.substring(0, extIndex)
  //           : currentFileName;
  //       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : "";
  //       setPdfView(fileURL);
  //       setfileName(currentFileName);
  //       setFileNameWithoutExt(withoutExt);
  //       setOriginalExtension(ext);
  //       setIsDetectingAttachmentType(true);
  //       try {
  //         const detectedLabel = await simulateAIDocumentTypeDetection(
  //           "",
  //           currentFileName,
  //           t,
  //         );
  //         setCurrentAttachmentAiSuggestion(detectedLabel);
  //       } finally {
  //         setIsDetectingAttachmentType(false);
  //       }
  //     }
  //   };
  const onTransctionChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file.name;

      // First validate the file
      if (!isValidFileType(file)) {
        toast.error(
          t("text.invalidFileType", "Only valid PDF files are allowed")
        );
        event.target.value = ""; // Reset the file input
        return;
      }

      const fileURL = URL.createObjectURL(file);
      const extIndex = fileName.lastIndexOf(".");
      const withoutExt =
        extIndex !== -1
          ? fileName.substring(0, extIndex)
          : fileName;
      const ext = extIndex !== -1 ? fileName.substring(extIndex) : "";

      // Ensure extension is .pdf
      if (ext.toLowerCase() !== ".pdf") {
        toast.error(t("text.onlyPdfAllowed", "Only PDF files are allowed"));
        event.target.value = "";
        return;
      }

      setPdfView(fileURL);
      setfileName(fileName);
      setFileNameWithoutExt(withoutExt);
      setOriginalExtension(ext);
      setCurrentAttachmentAiSuggestion(null);
      setIsDetectingAttachmentType(true);

      try {
        const detectedLabel = await simulateAIDocumentTypeDetection(
          "",
          fileName,
          t
        );
        setCurrentAttachmentAiSuggestion(detectedLabel);
        if (detectedLabel) {
          toast.info(
            t(
              "text.aiAttachmentCategorySuggestion",
              `AI suggests category: ${detectedLabel}`
            ),
            { autoClose: 3500 }
          );
        } else {
          toast.info(
            t(
              "text.aiNoSpecificCategoryForAttachment",
              "AI couldn't suggest a specific category."
            ),
            { autoClose: 3000 }
          );
        }
      } catch (aiError) {
        console.error("AI attachment category detection error:", aiError);
        toast.error(t("text.aiDetectionError"));
      } finally {
        setIsDetectingAttachmentType(false);
      }
    } else {
      // When no file is selected (user cancelled), reset everything
      setfileName("");
      setPdfView("");
      setFileNameWithoutExt("");
      setOriginalExtension("");
      setIsDetectingAttachmentType(false);
      setCurrentAttachmentAiSuggestion(null);

      // Ensure the input is cleared
      event.target.value = "";
    }
  };
  const addMoreRow = () => {
    if (!fileName || !pDate) {
      toast.warn(t("text.PleaseFillAttachmentDetails"));
      return;
    }

    const newRow = {
      id: Date.now(),
      pdFid: -1,
      pdfName: fileName,
      docMid: -1,
      keywords: keywords,
      subFtype: "",
      pDate: pDate,
      isMain: "",
      entryDate: moment().format("YYYY-MM-DD"),
      user_id: -1,
      pdfPath: "",
      pdfView: pdfView,
      srn: -1,
      isDelete: false,
    };

    const updatedTableData = [...tableData, newRow];
    setTableData(updatedTableData);
    formik.setFieldValue("member_DocFiles", updatedTableData);

    // Reset all file-related states
    setfileName("");
    setPdfView("");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setCurrentAttachmentAiSuggestion(null);

    // Reset the file input element
    const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const removeExtraRow = (id: any) => {
    const updatedTableData = tableData.filter((row) => row.id !== id);
    setTableData(updatedTableData);
    formik.setFieldValue("member_DocFiles", updatedTableData);
  };

  const back = useNavigate();
  const getAutocompleteValue = (
    options: SelectOption[],
    formikValue: string | null | number,
  ): SelectOption | null => {
    if (formikValue === null || formikValue === undefined) return null;
    return (
      options.find((option) => String(option.value) === String(formikValue)) ||
      null
    );
  };

  const handleReset = () => {
    formik.resetForm();
    setTableData([]);
    setPDate(today || "");
    setKeywords("");
    setfileName("");
    setPdfView("");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setCurrentAttachmentAiSuggestion(null);
    setIsDetectingAttachmentType(false);

    // Reset max file number
    getMaxFileNumber();

    // Reset division to initial value
    formik.setFieldValue(
      "divisionid",
      initialDivisionId === "" ? null : String(initialDivisionId),
    );
    // ✅ Reset subDeptID to null
    formik.setFieldValue("subDeptID", null);
    // Reset the file input element
    const fileInput = document.getElementById("pdf_attach_file_input") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }

    // Reset any other file inputs if they exist
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input: any) => {
      input.value = "";
    });
  };
  return (
    <div>
      <ToastApp />
      {loader && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: (theme) => theme.zIndex.drawer + 50,
          }}
        >
          {" "}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: 4,
              backgroundColor: "rgba(255,255,255,0.95)",
              borderRadius: "12px",
              boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
            }}
          >
            {" "}
            <img
              src={logo}
              alt="Loading..."
              style={{ width: "120px", height: "auto", marginBottom: "24px" }}
            />{" "}
            <LinearProgress
              color="primary"
              sx={{ width: "200px", height: "8px", borderRadius: "4px" }}
            />{" "}
            <Typography
              variant="subtitle1"
              sx={{ marginTop: 2, color: "text.secondary" }}
            >
              {" "}
              {t("text.processing", "Processing, please wait...")}{" "}
            </Typography>{" "}
          </Box>{" "}
        </Box>
      )}

      {/* <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "3vh",
          filter: loader ? "blur(5px)" : "none",
        }}
      > */}

      <Box
        sx={{
          px: 1,
          py: 1,
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          mt: {
            xs: "12vh",   // 📱 Mobile (zyada space)
            sm: "8vh",    // 📟 Tablet
            md: "3vh",    // 💻 Laptop (same as before)
          },
          filter: loader ? "blur(5px)" : "none",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {" "}
            {t("text.DocumentEntryAdd", "Document Entry Add")}{" "}
          </Typography>
          <Grid item sm={4} xs={12} style={{ marginTop: "-40px" }}>
            {" "}
            <Button
              type="button"
              onClick={() => back(-1)}
              variant="contained"
              style={{
                backgroundColor: `var(--header-background)`,
                minWidth: "40px",
              }}
            >
              {" "}
              <ArrowBackSharpIcon />{" "}
            </Button>{" "}
          </Grid>
          <Divider style={{ marginTop: "10px", marginBottom: "20px" }} />

          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fileNo"
                  name="fileNo"
                  label={
                    <span>
                      {t("text.EnterFileNo", "File No")}{" "}
                      <span
                        style={{
                          color:
                            formik.values.fileNo && !formik.errors.fileNo
                              ? "green"
                              : "red",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  value={formik.values.fileNo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.fileNo && Boolean(formik.errors.fileNo)}
                  helperText={
                    formik.touched.fileNo && (formik.errors.fileNo as string)
                  }
                  size="small"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="synopsis"
                  name="synopsis"
                  label={
                    <span>
                      {t("text.EnterSynopsis", "Synopsis")}{" "}
                      <span
                        style={{
                          color:
                            formik.values.synopsis && !formik.errors.synopsis
                              ? "green"
                              : "red",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  value={formik.values.synopsis}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.synopsis && Boolean(formik.errors.synopsis)
                  }
                  helperText={
                    formik.touched.synopsis &&
                    (formik.errors.synopsis as string)
                  }
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fileDef"
                  name="fileDef"
                  label={t("text.EnterFileDef", "File Definition")}
                  value={formik.values.fileDef}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  size="small"
                  fullWidth
                />
              </Grid>
              {/* <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="perFr"
                  name="perFr"
                  label={t("text.EnterPeriodFileFrom", "Period From")}
                  value={formik.values.perFr}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="perUt"
                  name="perUt"
                  label={t("text.EnterPeriodFileUpto", "Period Upto")}
                  value={formik.values.perUt}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                />
              </Grid> */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="authPersn"
                  name="authPersn"
                  label={t(
                    "text.EnterAuthenticatePerson",
                    "Authenticate Person",
                  )}
                  value={formik.values.authPersn}
                  onChange={formik.handleChange}
                  size="small"
                  fullWidth
                  disabled
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fDate"
                  name="fDate"
                  label={t("text.EnterFileDate", "File Date")}
                  value={formik.values.fDate}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                />
              </Grid>

              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="fileTypId"
                  options={TypeOption}
                  value={getAutocompleteValue(
                    TypeOption,
                    formik.values.fileTypId,
                  )}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "fileTypId",
                      newValue ? String(newValue.value) : null,
                    );
                  }}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectFile", "Select File Type")}{" "}
                          <span
                            style={{
                              color: formik.values.fileTypId && !formik.errors.fileTypId
                                ? "green"
                                : "red"
                            }}
                          >
                            *
                          </span>
                        </span>
                      }
                      error={
                        formik.touched.fileTypId &&
                        Boolean(formik.errors.fileTypId)
                      }
                      helperText={
                        formik.touched.fileTypId &&
                        (formik.errors.fileTypId as string)
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="subsubjId"
                  options={Subject}
                  value={getAutocompleteValue(Subject, formik.values.subsubjId)}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "subsubjId",
                      newValue ? String(newValue.value) : null,
                    );
                  }}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label={
                      //   <span>
                      //     {t("text.SelectSubject", "Select Subject")} *
                      //   </span>
                      // }
                      label={
                        <span>
                          {t("text.SelectSubject", "Select Subject")}{" "}
                          <span
                            style={{
                              color: formik.values.subsubjId && !formik.errors.subsubjId
                                ? "green"
                                : "red"
                            }}
                          >
                            *
                          </span>
                        </span>
                      }
                      error={
                        formik.touched.subsubjId &&
                        Boolean(formik.errors.subsubjId)
                      }
                      helperText={
                        formik.touched.subsubjId &&
                        (formik.errors.subsubjId as string)
                      }
                    />
                  )}
                />
              </Grid>

              {/* Division/Department Field */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="divisionid"
                  options={Division}
                  value={getAutocompleteValue(
                    Division,
                    formik.values.divisionid,
                  )}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "divisionid",
                      newValue ? String(newValue.value) : null,
                    );
                    getSubDepartment(Number(newValue?.value || -1));
                  }}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment", "Select Division/Department")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      error={formik.touched.divisionid && Boolean(formik.errors.divisionid)}
                      helperText={formik.touched.divisionid && (formik.errors.divisionid as string)}
                    />
                  )}
                />
              </Grid>

              {/* New Sub Department Field (Added) */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="subDeptID"
                  options={subDepartments}
                  value={getAutocompleteValue(
                    subDepartments,
                    formik.values.subDeptID,
                  )}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    String(option.value) === String(value?.value)
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "subDeptID",
                      newValue ? String(newValue.value) : null,
                    );
                  }}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        t("text.SelectSubDept", "Select Sub Department")
                        // <span>
                        //   {t("text.SelectSubDept", "Select Sub Department")}{" "}
                        //   <span
                        //     style={{
                        //       color:
                        //         formik.values.subDeptID &&
                        //         !formik.errors.subDeptID
                        //           ? "green"
                        //           : "red",
                        //     }}
                        //   >
                        //     *
                        //   </span>
                        // </span>
                      }
                      error={
                        formik.touched.subDeptID &&
                        Boolean(formik.errors.subDeptID)
                      }
                      helperText={
                        formik.touched.subDeptID &&
                        (formik.errors.subDeptID as string)
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ marginY: 2 }}>
                  <Typography variant="subtitle1">
                    {t("text.Attachments", "Attachments")}*
                  </Typography>
                </Divider>
              </Grid>
              <Grid item container xs={12} spacing={2} alignItems="flex-start">
                <Grid item xs={12} lg={2.5}>
                  <TextField
                    label={t("text.PeriodDate", "Period Date")}
                    value={pDate}
                    onChange={(e: any) => setPDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    type="date"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} lg={2}>
                  <TextField
                    label={t("text.Keywords", "Keywords")}
                    value={keywords}
                    onChange={(e: any) => setKeywords(e.target.value)}
                    size="small"
                    fullWidth
                  />
                </Grid>


                <Grid item xs={12} lg={3}>
                  <TextField
                    id="pdf_attach_file_input"
                    name="pdf_attach_input"
                    label={t("text.AttachedFile", "Attach File")}
                    onChange={onTransctionChange}
                    size="small"
                    type="file"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      accept: ".pdf,application/pdf" // Only accept PDF files
                    }}
                  />
                  <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
                    {t("text.allowedFileTypes", "Only PDF files are allowed")}
                  </Typography>
                  {isDetectingAttachmentType && fileName && (
                    <Box sx={{ width: '100%', mt: 0.5 }}>
                      <LinearProgress variant="indeterminate" />
                      <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
                        {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
                      </Typography>
                    </Box>
                  )}
                  {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
                    <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1 }}>
                      <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="caption" component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                        {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
                      </Typography>
                    </Box>
                  )}
                </Grid>


                <Grid item xs={12} lg={3}>
                  <TextField
                    id="fileName_display"
                    name="fileName_display"
                    label={t("text.EnterFileName", "Selected File")}
                    value={fileNameWithoutExt}
                    onChange={(e) => {
                      let input = e.target.value.trim();

                      // Don't automatically remove dots - they might be part of the name
                      // Just ensure the final filename will have .pdf extension

                      const forcedExt = ".pdf";

                      setFileNameWithoutExt(input);
                      setOriginalExtension(forcedExt);
                      setfileName(input + forcedExt);
                    }}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    InputProps={{
                      endAdornment: originalExtension ? (
                        <InputAdornment
                          position="end"
                          disableTypography
                          sx={{
                            pointerEvents: "none",
                            userSelect: "none",
                            color: "green",
                            fontWeight: "bold"
                          }}
                        >
                          {originalExtension}
                        </InputAdornment>
                      ) : null,
                    }}
                    InputLabelProps={{
                      shrink: Boolean(fileNameWithoutExt || originalExtension),
                    }}
                    error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
                    helperText={
                      fileName && !fileName.toLowerCase().endsWith(".pdf")
                        ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
                        : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={1.5}>
                  <Button
                    startIcon={<AddCircleIcon />}
                    variant="contained"
                    color="info"
                    fullWidth
                    onClick={addMoreRow}
                    disabled={!fileName || !pDate}
                  >
                    {t("text.add", "Add")}
                  </Button>
                </Grid>
              </Grid>

              {tableData.length > 0 && (
                <Grid
                  item
                  xs={12}
                  sx={{ marginTop: "15px", overflowX: "auto" }}
                >
                  <Table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      border: "1px solid #ddd",
                    }}
                    size="small"
                  >
                    <thead style={{ backgroundColor: "#e0e0e0" }}>
                      <tr>
                        <th
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {t("text.Action", "Action")}
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {t("text.PeriodDate", "Period Date")}
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {t("text.Keywords", "Keywords")}
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {t("text.FileName", "File Name")}
                        </th>
                        <th
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {t("text.PdfFile", "PDF File")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData?.map((row: any) => (
                        <tr key={row.id}>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <DeleteIcon
                              style={{ color: "darkred", cursor: "pointer" }}
                              onClick={() => removeExtraRow(row.id)}
                            />
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            {row.pDate
                              ? moment(row.pDate).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {row.keywords || "-"}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {row.pdfName}
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            {row.pdfView ? (
                              <Typography
                                onClick={() => modalOpenHandle1(row.pdfView)}
                                sx={{
                                  color: "primary.main",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                {t("text.Preview", "Preview")}
                              </Typography>
                            ) : (
                              t("text.NoPreview", "No Preview")
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  {/* Modal section starts here */}
                  <Modal
                    open={Opens}
                    onClose={handlePanClose1}
                    aria-labelledby="modal-title"
                  >
                    <Box sx={modalStyle}>
                      {Img ? (
                        <embed
                          src={Img}
                          type="application/pdf"
                          style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "500px",
                          }}
                        />
                      ) : (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <img
                            src={nopdf}
                            alt="No PDF"
                            style={{ maxWidth: "80%" }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Modal>
                  {/* Modal section ends here */}
                </Grid>
              )}

              <Grid
                item
                xs={12}
                container
                spacing={2}
                justifyContent="center"
                style={{ marginTop: "20px" }}
              >
                <Grid item xs={12} sm={4} md={3}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                    }}
                    disabled={loader}
                  >
                    {t("text.save", "Save")}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <Button
                    type="button"
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: "#F43F5E", color: "white" }}
                    onClick={handleReset}
                  >
                    {t("text.reset", "Reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Box>
    </div>
  );
};

export default DocumentEntryAdd;
